{
  "level": "q308",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q308",
    "objects": "AREAS.E3:q308.e3",
    "mesh": "TREES.E3:q308.e3"
  },
  "spawn_point": {
    "position": [
      1346.5763828622357,
      1238.0848237418572,
      -12.837890625
    ],
    "facing_rad": 0.0,
    "look_point": [
      1346.5763828622357,
      1338.0848237418572,
      -12.837890625
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      183.38427734375,
      -2849.047607421875,
      -36.837890625
    ],
    "bbox_max": [
      6992.10546875,
      7450.0,
      1857.3123779296875
    ],
    "vertex_count": 1372,
    "vertices": [
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        235.99966430664062,
        5035.24365234375,
        -36.837890625
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        183.38427734375,
        7446.69482421875,
        -22.699951171875
      ],
      [
        183.38438415527344,
        7446.69482421875,
        679.593505859375
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        816.3760375976562,
        7327.39501953125,
        652.46484375
      ],
      [
        183.38442993164062,
        7446.69482421875,
        976.300048828125
      ],
      [
        2400.0,
        -2849.047607421875,
        1857.3123779296875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        2400.0,
        -1319.93994140625,
        329.84539794921875
      ],
      [
        2400.0,
        -1246.433349609375,
        296.433349609375
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -867.0938720703125,
        16.99639320373535
      ],
      [
        1550.0001220703125,
        2011.7158203125,
        980.0
      ],
      [
        1550.0,
        1830.0,
        980.0
      ],
      [
        1910.0,
        2050.0,
        980.0
      ],
      [
        1910.0,
        1940.0999755859375,
        980.0
      ],
      [
        1945.0999755859375,
        1931.0999755859375,
        980.0
      ],
      [
        1910.0,
        1940.0999755859375,
        980.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1910.0,
        1896.0,
        1060.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1917.3709716796875,
        1888.11865234375,
        1060.0
      ],
      [
        1910.0,
        1896.0001220703125,
        1060.0
      ],
      [
        1910.0,
        1895.489501953125,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      [
        1704.5103759765625,
        1830.0,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1814.6104736328125,
        1940.0999755859375,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1655.0,
        1830.0,
        140.0
      ],
      [
        1655.0,
        1830.0,
        120.0
      ],
      [
        1730.0684814453125,
        1830.0,
        140.0
      ],
      [
        1745.6768798828125,
        1830.0,
        140.0
      ],
      [
        1655.0001220703125,
        1830.0,
        140.0
      ],
      [
        1730.0684814453125,
        1830.0,
        140.0
      ],
      [
        1723.4124755859375,
        1690.0,
        1060.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        1655.0,
        1690.0,
        140.0
      ],
      [
        1655.0,
        1690.0,
        120.0
      ],
      [
        1655.0,
        1830.0,
        350.0
      ],
      [
        1655.0,
        1689.9998779296875,
        350.0
      ],
      [
        1225.0,
        1690.0,
        270.0
      ],
      [
        1170.0,
        1690.0,
        230.0
      ],
      [
        1225.0,
        1690.0,
        329.0
      ],
      [
        1225.0,
        1690.0,
        270.0
      ],
      [
        1746.4769287109375,
        1690.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        140.0
      ],
      [
        1655.0001220703125,
        1690.0,
        140.0
      ],
      [
        1730.2777099609375,
        1690.0,
        120.0
      ],
      [
        1746.4769287109375,
        1690.0,
        120.0
      ],
      [
        1730.2777099609375,
        1690.0,
        120.0
      ],
      [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      [
        1570.0,
        560.0,
        258.0
      ],
      [
        1570.0,
        560.0,
        338.0
      ],
      [
        1570.0,
        560.0,
        140.0
      ],
      [
        1570.0,
        560.0,
        258.0
      ],
      [
        1640.0,
        560.0,
        348.0
      ],
      [
        1640.0,
        560.0,
        338.0
      ],
      [
        1660.0,
        560.0,
        348.0
      ],
      [
        1660.0,
        560.0,
        338.0
      ],
      [
        1480.0,
        560.0,
        338.0
      ],
      [
        1480.0,
        560.0,
        258.0
      ],
      [
        1480.0,
        560.0,
        140.0
      ],
      [
        1480.0,
        560.0,
        258.0
      ],
      [
        1480.0,
        630.0,
        103.0
      ],
      [
        1480.0,
        630.0,
        104.0
      ],
      [
        1480.0,
        630.0,
        140.0
      ],
      [
        1480.0,
        630.0,
        258.0
      ],
      [
        1522.5999755859375,
        630.0,
        160.0
      ],
      [
        1522.5999755859375,
        590.0,
        160.0
      ],
      [
        1522.5999755859375,
        630.0,
        80.0
      ],
      [
        1522.5999755859375,
        628.0,
        80.0
      ],
      [
        1522.5999755859375,
        628.0,
        80.0
      ],
      [
        1522.5999755859375,
        610.0,
        80.0
      ],
      [
        1522.5999755859375,
        610.0,
        90.0
      ],
      [
        1522.5999755859375,
        610.0,
        80.0
      ],
      [
        1522.5999755859375,
        630.0,
        317.0
      ],
      [
        1522.5999755859375,
        600.0,
        317.0
      ],
      [
        1570.0,
        630.0,
        140.0
      ],
      [
        1570.0,
        630.0,
        258.0
      ],
      [
        1660.0,
        630.0,
        348.0
      ],
      [
        1660.0,
        630.0,
        338.0
      ],
      [
        1640.0,
        630.0,
        348.0
      ],
      [
        1640.0,
        630.0,
        338.0
      ],
      [
        1522.5999755859375,
        670.0,
        80.0
      ],
      [
        1522.5999755859375,
        630.0,
        80.0
      ],
      [
        1522.5999755859375,
        630.0,
        160.0
      ],
      [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      [
        1522.5999755859375,
        669.4284057617188,
        140.0
      ],
      [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      [
        1522.5999755859375,
        669.4284057617188,
        140.0
      ],
      [
        1522.5999755859375,
        669.4284057617188,
        120.0
      ],
      [
        1570.0,
        650.0,
        338.0
      ],
      [
        1570.0,
        650.0,
        258.0
      ],
      [
        1570.0,
        650.0,
        140.0
      ],
      [
        1570.0,
        650.0,
        258.0
      ],
      [
        1660.0,
        650.0,
        348.0
      ],
      [
        1660.0,
        650.0,
        338.0
      ],
      [
        1640.0,
        650.0,
        348.0
      ],
      [
        1640.0,
        650.0,
        338.0
      ],
      [
        1570.0,
        650.0,
        80.0
      ],
      [
        1522.5999755859375,
        650.0,
        80.0
      ],
      [
        1522.5999755859375,
        650.0,
        160.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1770.0,
        1555.0,
        140.0
      ],
      [
        1770.0,
        1666.4769287109375,
        140.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        120.0
      ],
      [
        1814.0194091796875,
        1469.9998779296875,
        120.0
      ],
      [
        1770.0,
        1666.4769287109375,
        120.0
      ],
      [
        1770.0,
        1555.0,
        120.0
      ],
      [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      [
        1814.019287109375,
        1469.9998779296875,
        135.0
      ],
      [
        1770.0,
        700.0,
        258.0
      ],
      [
        1770.0,
        700.0,
        338.0
      ],
      [
        1683.5,
        1400.0,
        140.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1630.0,
        1450.0,
        140.0
      ],
      [
        1655.0,
        1450.0,
        135.0
      ],
      [
        1630.0,
        1470.0,
        140.0
      ],
      [
        1630.0,
        1450.0001220703125,
        120.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1655.0,
        1470.0,
        138.0
      ],
      [
        1630.0,
        1470.0,
        138.0
      ],
      [
        1630.0,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1450.0,
        138.0
      ],
      [
        1655.0,
        1450.0,
        138.0
      ],
      [
        1655.0001220703125,
        1450.0,
        140.0
      ],
      [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      [
        1653.0,
        1468.0,
        138.0
      ],
      [
        1650.0,
        1450.0,
        135.0
      ],
      [
        1650.0,
        1450.0,
        135.0
      ],
      [
        1680.0,
        1620.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1665.0,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1680.0,
        1610.0,
        135.0
      ],
      [
        1690.0,
        1610.0,
        135.0
      ],
      [
        1680.0,
        1655.0,
        135.0
      ],
      [
        1690.0,
        1655.0,
        135.0
      ],
      [
        1770.0,
        1468.0,
        138.0
      ],
      [
        1765.0001220703125,
        1468.0,
        138.0
      ],
      [
        1670.0,
        1468.0,
        138.0
      ],
      [
        1655.0,
        1468.0,
        138.0
      ],
      [
        1770.0,
        1450.0,
        138.0
      ],
      [
        1655.0,
        1450.0,
        135.0
      ],
      [
        1695.0,
        1450.0,
        135.0
      ],
      [
        1695.0,
        1450.0,
        135.0
      ],
      [
        1630.0,
        1450.0,
        120.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        138.0
      ],
      [
        1660.0,
        1400.0,
        140.0
      ],
      [
        1697.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1695.0,
        1441.0,
        138.0
      ],
      [
        1660.0,
        1441.0001220703125,
        138.0
      ],
      [
        1660.0,
        1440.0001220703125,
        140.0
      ],
      [
        1683.5,
        1410.0,
        140.0
      ],
      [
        1683.5,
        1400.0,
        140.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1653.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1655.0001220703125,
        1441.0001220703125,
        138.0
      ],
      [
        1630.0,
        920.0,
        80.0
      ],
      [
        1680.0,
        920.0,
        80.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        920.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1630.0,
        840.0,
        100.0
      ],
      [
        1630.0,
        680.0,
        80.0
      ],
      [
        1630.0,
        700.0,
        80.0
      ],
      [
        1630.0,
        700.0,
        80.0
      ],
      [
        1630.0,
        700.0,
        78.0
      ],
      [
        1630.0,
        810.0,
        100.0
      ],
      [
        1680.0,
        810.0,
        100.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1630.0,
        810.0,
        140.0
      ],
      [
        1630.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1630.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        840.0,
        120.0
      ],
      [
        1630.0,
        840.0,
        120.0
      ],
      [
        1630.0,
        840.0,
        100.0
      ],
      [
        1680.0,
        840.0,
        100.0
      ],
      [
        1667.5,
        882.5,
        140.0
      ],
      [
        1667.5,
        877.5,
        140.0
      ],
      [
        1667.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        882.5,
        140.0
      ],
      [
        1672.5,
        877.5,
        140.0
      ],
      [
        1680.0,
        960.0,
        98.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        80.0
      ],
      [
        1680.0,
        960.0,
        80.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        118.0
      ],
      [
        1680.0,
        920.0,
        118.0
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1630.0,
        960.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1680.0,
        920.0,
        120.0
      ],
      [
        1680.0,
        940.0,
        118.0
      ],
      [
        1680.0,
        940.0,
        120.0
      ],
      [
        1650.0,
        960.0,
        118.0
      ],
      [
        1650.0,
        960.0,
        120.0
      ],
      [
        1680.0,
        960.0,
        98.0
      ],
      [
        1680.0,
        940.0,
        98.0
      ],
      [
        1630.0,
        940.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        98.0
      ],
      [
        1680.0,
        940.0,
        100.0
      ],
      [
        1680.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        940.0,
        100.0
      ],
      [
        1630.0,
        1026.25,
        87.49999237060547
      ],
      [
        1680.0,
        1026.25,
        87.49999237060547
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1657.0,
        1150.0,
        138.0
      ],
      [
        1657.0,
        1140.0,
        138.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1633.0,
        1140.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1633.0,
        1150.0,
        120.0
      ],
      [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      [
        1650.0,
        1140.0,
        133.3333282470703
      ],
      [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      [
        1650.0,
        1150.0,
        131.3333282470703
      ],
      [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      [
        1650.0,
        1150.0,
        131.3333282470703
      ],
      [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      [
        1650.0,
        1140.0,
        133.3333282470703
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1650.0,
        1026.25,
        87.49999237060547
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1650.0,
        1170.0,
        100.0
      ],
      [
        1653.0,
        993.0,
        120.0
      ],
      [
        1660.0,
        993.0,
        120.0
      ],
      [
        1653.0,
        993.0,
        120.0
      ],
      [
        1650.0,
        993.0,
        120.0
      ],
      [
        1770.0,
        920.0,
        120.0
      ],
      [
        1770.0,
        920.0,
        118.0
      ],
      [
        1750.0,
        810.0,
        118.0
      ],
      [
        1750.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        120.0
      ],
      [
        1680.0,
        810.0,
        118.0
      ],
      [
        1750.0,
        840.0,
        118.0
      ],
      [
        1680.0,
        840.0,
        118.0
      ],
      [
        1750.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        1120.0,
        140.0
      ],
      [
        1690.0,
        1200.0,
        139.99998474121094
      ],
      [
        1690.0,
        1120.0,
        139.99998474121094
      ],
      [
        1690.0,
        995.0,
        140.0
      ],
      [
        1690.0,
        982.5,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        920.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1690.0,
        920.0,
        120.0
      ],
      [
        1720.0,
        940.0,
        98.0
      ],
      [
        1720.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        995.0,
        139.99998474121094
      ],
      [
        1710.0,
        970.0,
        140.0
      ],
      [
        1750.0,
        1220.0,
        139.99998474121094
      ],
      [
        1710.0,
        1220.0,
        140.0
      ],
      [
        1690.0,
        1210.0,
        100.0
      ],
      [
        1690.0,
        1210.0,
        140.0
      ],
      [
        1710.0,
        1220.0,
        139.99998474121094
      ],
      [
        1690.0,
        1200.0,
        140.0
      ],
      [
        1718.0001220703125,
        960.0,
        98.0
      ],
      [
        1718.0001220703125,
        960.0,
        100.0
      ],
      [
        1718.888916015625,
        958.8889770507812,
        98.0
      ],
      [
        1718.0001220703125,
        960.0,
        98.0
      ],
      [
        1718.888916015625,
        958.8889770507812,
        98.0
      ],
      [
        1720.0,
        957.5001220703125,
        98.0
      ],
      [
        1718.0001220703125,
        960.0,
        100.0
      ],
      [
        1718.888916015625,
        958.8889770507812,
        100.0
      ],
      [
        1718.888916015625,
        958.8889770507812,
        100.0
      ],
      [
        1720.0,
        957.5001220703125,
        100.0
      ],
      [
        1690.0,
        1210.0,
        100.0
      ],
      [
        1690.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        98.0
      ],
      [
        1690.0,
        940.0,
        98.0
      ],
      [
        1690.0,
        960.0,
        98.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1685.9998779296875,
        920.0,
        80.0
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1690.0,
        1210.0,
        119.99980163574219
      ],
      [
        1680.0,
        1200.0,
        112.79998016357422
      ],
      [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      [
        1530.0,
        920.0,
        140.0
      ],
      [
        1530.0,
        940.0,
        140.0
      ],
      [
        1530.0,
        760.0,
        140.0
      ],
      [
        1530.0,
        920.0,
        140.0
      ],
      [
        1530.0,
        1120.0,
        118.0
      ],
      [
        1530.0,
        1120.0,
        120.0
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1690.0,
        138.0
      ],
      [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      [
        1548.0,
        1450.0,
        138.0
      ],
      [
        1547.9998779296875,
        1684.999755859375,
        138.0
      ],
      [
        1547.9998779296875,
        1480.0,
        138.0
      ],
      [
        1547.9998779296875,
        1507.455810546875,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      [
        1630.0,
        1468.0,
        138.0
      ],
      [
        1530.0,
        1450.0,
        120.0
      ],
      [
        1530.0,
        1450.0,
        138.0
      ],
      [
        1530.0,
        1690.0,
        138.0
      ],
      [
        1530.0,
        1120.0,
        100.0
      ],
      [
        1530.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1170.0,
        140.0
      ],
      [
        1530.0,
        1170.0,
        100.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        118.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1530.0,
        1140.0,
        120.0
      ],
      [
        1530.0,
        1140.0,
        118.0
      ],
      [
        1617.0,
        1170.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1617.0,
        1160.0,
        118.0
      ],
      [
        1599.0,
        1170.0,
        104.00003051757812
      ],
      [
        1599.0,
        1160.0,
        104.00003051757812
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1130.0,
        140.0
      ],
      [
        1555.0,
        1128.0,
        138.0
      ],
      [
        1555.0,
        1120.0,
        138.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1615.0,
        1128.0,
        138.0
      ],
      [
        1615.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1128.0,
        138.0
      ],
      [
        1535.0,
        1130.0,
        140.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        130.0
      ],
      [
        1615.0,
        1120.0,
        130.0
      ],
      [
        1535.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        700.0,
        80.0
      ],
      [
        1530.0,
        700.0,
        78.0
      ],
      [
        1530.0,
        670.0,
        80.0
      ],
      [
        1530.0,
        680.0,
        80.0
      ],
      [
        1530.0,
        680.0,
        80.0
      ],
      [
        1530.0,
        700.0,
        80.0
      ],
      [
        1530.0,
        725.0,
        100.0
      ],
      [
        1535.0,
        725.0,
        100.0
      ],
      [
        1600.0,
        860.0,
        140.0
      ],
      [
        1600.0,
        890.0,
        140.0
      ],
      [
        1600.0,
        920.0,
        140.0
      ],
      [
        1580.0,
        845.0,
        138.5
      ],
      [
        1598.0,
        845.0,
        138.5
      ],
      [
        1580.0,
        845.0,
        140.0
      ],
      [
        1598.0,
        845.0,
        140.0
      ],
      [
        1600.0,
        860.0,
        140.0
      ],
      [
        1598.0,
        860.0,
        140.0
      ],
      [
        1600.0,
        810.0,
        140.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        80.0
      ],
      [
        1630.0,
        960.0,
        80.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1600.0,
        940.0,
        140.0
      ],
      [
        1530.0,
        940.0,
        140.0
      ],
      [
        1600.0,
        920.0,
        140.0
      ],
      [
        1600.0,
        940.0,
        140.0
      ],
      [
        1530.0,
        1110.0,
        120.0
      ],
      [
        1530.0,
        1120.0,
        100.0
      ],
      [
        1530.0,
        1110.0,
        120.0
      ],
      [
        1535.0,
        1120.0,
        138.0
      ],
      [
        1535.0,
        1110.0,
        138.0
      ],
      [
        1250.0,
        880.0,
        139.99998474121094
      ],
      [
        1250.0,
        720.0,
        140.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        120.0
      ],
      [
        1480.0,
        1350.0,
        140.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1120.0,
        100.0
      ],
      [
        1480.0,
        1170.0,
        100.0
      ],
      [
        1480.0,
        1170.0,
        140.0
      ],
      [
        1480.0,
        1170.0,
        100.0
      ],
      [
        1497.7283935546875,
        1217.7266845703125,
        140.0
      ],
      [
        1505.5,
        1214.5703125,
        140.0
      ],
      [
        1513.2716064453125,
        1232.2733154296875,
        140.0
      ],
      [
        1505.5,
        1235.4296875,
        140.0
      ],
      [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1497.7283935546875,
        1232.2733154296875,
        140.0
      ],
      [
        1494.6551513671875,
        1225.0,
        140.0
      ],
      [
        1505.5,
        1214.5703125,
        140.0
      ],
      [
        1513.2716064453125,
        1217.7266845703125,
        140.0
      ],
      [
        1505.5,
        1235.4296875,
        140.0
      ],
      [
        1497.7283935546875,
        1232.2733154296875,
        140.0
      ],
      [
        1516.3448486328125,
        1225.0,
        140.0
      ],
      [
        1513.2716064453125,
        1232.2733154296875,
        140.0
      ],
      [
        1494.6551513671875,
        1225.0,
        140.0
      ],
      [
        1497.7283935546875,
        1217.7266845703125,
        140.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        120.0
      ],
      [
        1480.0,
        1120.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1480.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        1140.0,
        118.0
      ],
      [
        1480.0,
        1120.0,
        130.0
      ],
      [
        1530.0,
        1120.0,
        130.0
      ],
      [
        1480.0,
        1130.0,
        140.0
      ],
      [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1610.0,
        138.0
      ],
      [
        1480.0,
        1419.553466796875,
        138.0
      ],
      [
        1480.0,
        1380.0,
        138.0
      ],
      [
        1480.0,
        1380.0,
        138.0
      ],
      [
        1480.0,
        1380.0,
        140.0
      ],
      [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      [
        1361.7835693359375,
        1625.1204833984375,
        140.0
      ],
      [
        1361.7835693359375,
        1625.1204833984375,
        140.0
      ],
      [
        1257.887939453125,
        1690.0,
        140.0
      ],
      [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      [
        1266.5,
        1580.0,
        138.0
      ],
      [
        1266.5,
        1590.0,
        138.0
      ],
      [
        1266.5,
        1580.0,
        138.0
      ],
      [
        1250.0,
        1590.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      [
        1250.0,
        1598.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        112.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1590.0,
        110.11428833007812
      ],
      [
        1250.0,
        1598.0,
        110.11428833007812
      ],
      [
        1250.0,
        1120.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1120.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      [
        1336.0,
        1160.0,
        118.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1336.0,
        1160.0,
        118.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1336.0,
        1150.0,
        118.0
      ],
      [
        1346.0,
        1170.0,
        120.0
      ],
      [
        1346.0,
        1160.0,
        120.0
      ],
      [
        1312.0,
        1160.0,
        104.00001525878906
      ],
      [
        1312.0,
        1150.0,
        104.00001525878906
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1128.0,
        138.0
      ],
      [
        1455.0,
        1130.0,
        140.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1128.0,
        138.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        140.0
      ],
      [
        1475.0,
        1130.0,
        140.0
      ],
      [
        1475.0,
        1128.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        1455.0,
        1120.0,
        130.0
      ],
      [
        1395.0,
        1120.0,
        130.0
      ],
      [
        1475.0,
        1120.0,
        130.0
      ],
      [
        1290.0,
        1160.0,
        140.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1290.0,
        1160.0,
        138.0
      ],
      [
        1480.0,
        1420.0,
        138.0
      ],
      [
        1280.0,
        1180.0001220703125,
        138.0
      ],
      [
        1280.0,
        1180.0001220703125,
        140.0
      ],
      [
        1265.0,
        1205.0,
        100.0
      ],
      [
        1250.0,
        1190.0,
        100.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1250.0,
        1140.0,
        118.0
      ],
      [
        1250.0,
        1140.0,
        120.0
      ],
      [
        1480.0,
        720.0,
        139.99998474121094
      ],
      [
        1480.0,
        880.0,
        140.0
      ],
      [
        1480.0,
        700.0,
        100.0
      ],
      [
        1480.0,
        960.0,
        100.0
      ],
      [
        1480.0,
        700.0,
        100.0
      ],
      [
        1480.0,
        950.7692260742188,
        80.0
      ],
      [
        1480.0,
        680.0,
        80.0
      ],
      [
        1480.0,
        700.0,
        80.0
      ],
      [
        1480.0,
        700.0,
        80.0
      ],
      [
        1480.0,
        700.0,
        78.0
      ],
      [
        1472.0,
        670.0,
        80.0
      ],
      [
        1472.0,
        675.0,
        80.0
      ],
      [
        1470.0,
        675.0,
        80.0
      ],
      [
        1472.0,
        675.0,
        80.0
      ],
      [
        1480.0,
        680.0,
        61.66666793823242
      ],
      [
        1480.0,
        670.0,
        61.66666793823242
      ],
      [
        1472.0,
        670.0,
        100.0
      ],
      [
        1472.0,
        675.0,
        100.0
      ],
      [
        1470.0,
        675.0,
        100.0
      ],
      [
        1472.0,
        675.0,
        100.0
      ],
      [
        1480.0,
        960.0,
        80.0
      ],
      [
        1380.0,
        960.0,
        80.0
      ],
      [
        1310.0,
        880.0,
        140.0
      ],
      [
        1320.0,
        880.0,
        140.0
      ],
      [
        1310.0,
        880.0,
        140.0
      ],
      [
        1250.0,
        880.0,
        140.0
      ],
      [
        1480.0,
        880.0,
        140.0
      ],
      [
        1320.0,
        880.0,
        140.0
      ],
      [
        1472.0,
        670.0,
        140.0
      ],
      [
        1472.0,
        675.0,
        140.0
      ],
      [
        1470.0,
        675.0,
        140.0
      ],
      [
        1472.0,
        675.0,
        140.0
      ],
      [
        1510.0,
        936.6666870117188,
        81.66666412353516
      ],
      [
        1520.0,
        936.6666870117188,
        81.66666412353516
      ],
      [
        1510.0,
        936.6666870117188,
        81.66666412353516
      ],
      [
        1510.0,
        933.3333129882812,
        81.33333587646484
      ],
      [
        1500.0,
        960.0,
        100.0
      ],
      [
        1500.0,
        680.0,
        80.0
      ],
      [
        1500.0,
        700.0,
        80.0
      ],
      [
        1500.0,
        680.0,
        72.14286041259766
      ],
      [
        1500.0,
        670.0,
        72.14286041259766
      ],
      [
        1500.0,
        700.0,
        80.0
      ],
      [
        1500.0,
        700.0,
        78.0
      ],
      [
        1500.0,
        960.0,
        98.0
      ],
      [
        1510.0,
        680.0,
        80.0
      ],
      [
        1510.0,
        700.0,
        80.0
      ],
      [
        1510.0,
        700.0,
        80.0
      ],
      [
        1510.0,
        700.0,
        78.0
      ],
      [
        1510.0,
        680.0,
        77.38095092773438
      ],
      [
        1510.0,
        670.0,
        77.38095092773438
      ],
      [
        1510.0,
        880.0,
        100.0
      ],
      [
        1250.0,
        1030.0,
        80.0
      ],
      [
        1258.0,
        1030.0,
        140.0
      ],
      [
        1250.0,
        1030.0,
        140.0
      ],
      [
        1475.0,
        1110.0,
        138.0
      ],
      [
        1475.0,
        1120.0,
        138.0
      ],
      [
        480.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        1420.0,
        80.0
      ],
      [
        720.0,
        1450.0,
        60.0
      ],
      [
        500.0,
        1459.0,
        78.0
      ],
      [
        600.0,
        1459.0,
        78.0
      ],
      [
        445.0,
        1420.0,
        70.0
      ],
      [
        270.0,
        1420.0,
        70.0
      ],
      [
        450.0,
        1420.0,
        60.0
      ],
      [
        445.0,
        1420.0,
        70.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        400.0,
        1420.0,
        78.0
      ],
      [
        404.0,
        1420.0,
        80.0
      ],
      [
        404.0,
        1425.0,
        80.0
      ],
      [
        640.0,
        1460.0,
        140.0
      ],
      [
        720.0,
        1460.0,
        140.0
      ],
      [
        440.0,
        1420.0,
        98.0
      ],
      [
        450.0,
        1420.0,
        100.0
      ],
      [
        460.0,
        1420.0,
        100.0
      ],
      [
        460.0,
        1420.0,
        100.0
      ],
      [
        460.0,
        1420.0,
        98.0
      ],
      [
        890.0,
        1420.0,
        100.0
      ],
      [
        980.0,
        1420.0,
        100.0
      ],
      [
        780.0,
        1420.0,
        60.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        945.5584716796875,
        1540.0,
        100.0
      ],
      [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      [
        820.0,
        1450.0,
        100.0
      ],
      [
        871.110595703125,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1450.0,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        100.0
      ],
      [
        890.0,
        1472.83544921875,
        140.0
      ],
      [
        945.5584716796875,
        1540.0,
        140.0
      ],
      [
        871.110595703125,
        1450.0,
        140.0
      ],
      [
        871.110595703125,
        1450.0,
        100.0
      ],
      [
        1215.0,
        1620.0,
        100.0
      ],
      [
        1215.0,
        1570.0,
        100.0
      ],
      [
        1215.0,
        1690.0,
        100.0
      ],
      [
        1215.0,
        1620.0,
        100.0
      ],
      [
        1250.0,
        1420.0,
        100.0
      ],
      [
        1215.0,
        1420.0,
        100.0
      ],
      [
        1215.0,
        1570.0,
        100.0
      ],
      [
        1215.0,
        1670.0,
        118.0
      ],
      [
        1215.0,
        1420.0,
        118.0
      ],
      [
        1235.0,
        1420.0,
        118.0
      ],
      [
        1215.0,
        1670.0,
        120.0
      ],
      [
        1215.0,
        1420.0,
        120.0
      ],
      [
        1235.0,
        1420.0,
        120.0
      ],
      [
        1235.0,
        1420.0,
        118.0
      ],
      [
        1235.0,
        1420.0,
        120.0
      ],
      [
        1238.8043212890625,
        1590.0,
        118.0
      ],
      [
        1238.8043212890625,
        1598.0,
        118.0
      ],
      [
        1238.8043212890625,
        1590.0,
        118.0
      ],
      [
        1238.5,
        1590.0,
        120.0
      ],
      [
        1238.5,
        1580.0,
        120.0
      ],
      [
        1238.5,
        1580.0,
        120.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1037.2222900390625,
        1629.509521484375,
        120.0
      ],
      [
        1200.0,
        1690.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        100.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        1215.0,
        1590.0,
        100.0
      ],
      [
        1200.0,
        1590.0,
        100.0
      ],
      [
        980.0,
        1590.0,
        100.0
      ],
      [
        1000.0,
        1590.0,
        100.0
      ],
      [
        1000.0,
        1590.0,
        98.0
      ],
      [
        1000.0,
        1590.0,
        100.0
      ],
      [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      [
        1187.731689453125,
        1690.0,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1037.5947265625,
        1630.0,
        140.0
      ],
      [
        1187.731689453125,
        1630.0,
        140.0
      ],
      [
        1200.0,
        1460.0,
        140.0
      ],
      [
        1030.0,
        1460.0,
        140.0
      ],
      [
        1200.0,
        1460.0,
        100.0
      ],
      [
        1215.0,
        1460.0,
        100.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        980.0,
        1460.0,
        80.0
      ],
      [
        1000.0,
        1570.0,
        80.0
      ],
      [
        1000.0,
        1460.0,
        80.0
      ],
      [
        1030.0,
        1460.0,
        80.0
      ],
      [
        1200.0,
        1550.0,
        140.0
      ],
      [
        1200.0,
        1570.0,
        140.0
      ],
      [
        1200.0,
        1550.0,
        140.0
      ],
      [
        1200.0,
        1460.0,
        140.0
      ],
      [
        1000.0,
        1420.0,
        100.0
      ],
      [
        980.0,
        1420.0,
        100.0
      ],
      [
        1070.0,
        1420.0,
        100.0
      ],
      [
        1090.0,
        1420.0,
        100.0
      ],
      [
        1160.0,
        1420.0,
        100.0
      ],
      [
        1200.0,
        1420.0,
        100.0
      ],
      [
        1200.0,
        1420.0,
        100.0
      ],
      [
        980.0,
        1440.0,
        80.0
      ],
      [
        1030.0,
        1440.0,
        80.0
      ],
      [
        1120.0,
        1453.4285888671875,
        100.0
      ],
      [
        1110.0,
        1446.2857666015625,
        100.0
      ],
      [
        1110.0,
        1457.857177734375,
        100.0
      ],
      [
        1110.0,
        1446.2857666015625,
        100.0
      ],
      [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      [
        1110.0,
        1457.857177734375,
        100.0
      ],
      [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      [
        1120.0,
        1453.4285888671875,
        100.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        1030.0,
        1420.0,
        80.0
      ],
      [
        1000.0,
        1420.0,
        98.0
      ],
      [
        1000.0,
        1420.0,
        100.0
      ],
      [
        1215.0,
        1420.0,
        120.0
      ],
      [
        1180.0,
        1420.0,
        120.0
      ],
      [
        1180.0,
        1420.0,
        120.0
      ],
      [
        1160.0,
        1420.0,
        120.0
      ],
      [
        1180.0,
        1420.0,
        118.0
      ],
      [
        1160.0,
        1420.0,
        118.0
      ],
      [
        1215.0,
        1420.0,
        118.0
      ],
      [
        1180.0,
        1420.0,
        118.0
      ],
      [
        1160.0,
        1420.0,
        120.0
      ],
      [
        1160.0,
        1460.0,
        118.0
      ],
      [
        1160.0,
        1420.0,
        118.0
      ],
      [
        1140.0,
        1459.7427978515625,
        118.0
      ],
      [
        1140.0,
        1434.228515625,
        118.0
      ],
      [
        1140.0,
        1459.8214111328125,
        120.0
      ],
      [
        1140.0,
        1434.8214111328125,
        120.0
      ],
      [
        1153.0,
        1432.0,
        118.0
      ],
      [
        1140.0,
        1434.228515625,
        118.0
      ],
      [
        1142.5,
        1435.0,
        120.0
      ],
      [
        1160.0,
        1420.0,
        120.0
      ],
      [
        1153.0,
        1420.0,
        118.0
      ],
      [
        1153.0,
        1432.0,
        118.0
      ],
      [
        1140.0,
        1434.8214111328125,
        120.0
      ],
      [
        1142.5,
        1435.0,
        120.0
      ],
      [
        1120.0,
        1458.892822265625,
        118.0
      ],
      [
        1120.0,
        1458.392822265625,
        120.0
      ],
      [
        1120.0,
        1433.392822265625,
        120.0
      ],
      [
        1120.0,
        1433.892822265625,
        118.0
      ],
      [
        1130.0,
        1459.107177734375,
        120.0
      ],
      [
        1130.0,
        1459.607177734375,
        118.0
      ],
      [
        1130.0,
        1434.607177734375,
        118.0
      ],
      [
        1130.0,
        1434.107177734375,
        120.0
      ],
      [
        1120.0,
        1433.892822265625,
        118.0
      ],
      [
        1120.0,
        1433.392822265625,
        120.0
      ],
      [
        1130.0,
        1434.107177734375,
        120.0
      ],
      [
        1130.0,
        1434.607177734375,
        118.0
      ],
      [
        1140.0,
        1459.8214111328125,
        120.0
      ],
      [
        1135.5,
        1460.0,
        118.0
      ],
      [
        1130.0,
        1459.607177734375,
        118.0
      ],
      [
        1130.0,
        1459.107177734375,
        120.0
      ],
      [
        1140.0,
        1459.7427978515625,
        118.0
      ],
      [
        1135.5,
        1460.0,
        118.0
      ],
      [
        1110.0,
        1457.6785888671875,
        120.0
      ],
      [
        1110.0,
        1458.1785888671875,
        118.0
      ],
      [
        1110.0,
        1433.1785888671875,
        118.0
      ],
      [
        1110.0,
        1432.6785888671875,
        120.0
      ],
      [
        1110.0,
        1432.6785888671875,
        120.0
      ],
      [
        1110.0,
        1433.1785888671875,
        118.0
      ],
      [
        1090.0,
        1431.75,
        118.0
      ],
      [
        1090.0,
        1431.25,
        120.0
      ],
      [
        1120.0,
        1458.392822265625,
        120.0
      ],
      [
        1120.0,
        1458.892822265625,
        118.0
      ],
      [
        1110.0,
        1458.1785888671875,
        118.0
      ],
      [
        1110.0,
        1457.6785888671875,
        120.0
      ],
      [
        1160.0,
        1420.0,
        100.0199966430664
      ],
      [
        1130.0,
        1420.0,
        111.42857360839844
      ],
      [
        1140.0,
        1420.0,
        114.28571319580078
      ],
      [
        1120.0,
        1420.0,
        108.57142639160156
      ],
      [
        1110.0,
        1420.0,
        105.71428680419922
      ],
      [
        1120.0,
        1420.0,
        108.57142639160156
      ],
      [
        1130.0,
        1420.0,
        111.42857360839844
      ],
      [
        1110.0,
        1420.0,
        105.71428680419922
      ],
      [
        1090.0,
        1420.0,
        100.0
      ],
      [
        1140.0,
        1420.0,
        114.28571319580078
      ],
      [
        1160.0,
        1460.0,
        140.0
      ],
      [
        1160.0,
        1431.25,
        140.0
      ],
      [
        1142.5,
        1430.0,
        140.0
      ],
      [
        1160.0,
        1431.25,
        140.0
      ],
      [
        1142.5,
        1430.0,
        140.0
      ],
      [
        1142.5,
        1420.0,
        140.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1250.0,
        1170.0,
        100.0
      ],
      [
        1215.0,
        1170.0,
        100.0
      ],
      [
        1215.0,
        1220.0,
        100.0
      ],
      [
        1215.0,
        1220.0,
        100.0
      ],
      [
        1215.0,
        1420.0,
        100.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1215.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        120.0
      ],
      [
        1235.0,
        1170.0,
        118.0
      ],
      [
        1215.0,
        1170.0,
        118.0
      ],
      [
        1235.0,
        1400.0,
        138.0
      ],
      [
        1235.0,
        1390.0,
        138.0
      ],
      [
        1235.0,
        1390.0,
        140.0
      ],
      [
        1235.0,
        1390.0,
        138.0
      ],
      [
        1235.0,
        1400.0,
        138.0
      ],
      [
        1235.0,
        1400.0,
        140.0
      ],
      [
        1240.0,
        1400.0,
        138.0
      ],
      [
        1240.0,
        1400.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1200.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        100.0
      ],
      [
        1200.0,
        1390.0,
        100.0
      ],
      [
        1215.0,
        1390.0,
        100.0
      ],
      [
        1215.0,
        1300.0,
        100.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1215.0,
        1280.0,
        100.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1110.0,
        1403.7142333984375,
        100.0
      ],
      [
        1120.0,
        1396.5714111328125,
        100.0
      ],
      [
        1110.0,
        1403.7142333984375,
        100.0
      ],
      [
        1110.0,
        1392.142822265625,
        100.0
      ],
      [
        1110.0,
        1392.142822265625,
        100.0
      ],
      [
        1120.0,
        1392.7142333984375,
        100.0
      ],
      [
        1176.5,
        1420.0,
        118.0
      ],
      [
        1176.5,
        1390.0,
        118.0
      ],
      [
        1160.0,
        1390.0,
        108.57141876220703
      ],
      [
        1160.0,
        1420.0,
        108.57141876220703
      ],
      [
        1140.0,
        1415.1785888671875,
        120.0
      ],
      [
        1140.0,
        1390.1785888671875,
        120.0
      ],
      [
        1142.5,
        1415.0,
        120.0
      ],
      [
        1140.0,
        1415.1785888671875,
        120.0
      ],
      [
        1142.5,
        1415.0,
        120.0
      ],
      [
        1130.0,
        1390.892822265625,
        120.0
      ],
      [
        1140.0,
        1390.1785888671875,
        120.0
      ],
      [
        1160.0,
        1418.75,
        140.0
      ],
      [
        1160.0,
        1390.0,
        140.0
      ],
      [
        1160.0,
        1418.75,
        140.0
      ],
      [
        1142.5,
        1420.0,
        140.0
      ],
      [
        1030.0,
        1120.0,
        82.10526275634766
      ],
      [
        1030.0,
        1120.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1120.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1215.0,
        1030.0,
        118.0
      ],
      [
        1235.0,
        1030.0,
        118.0
      ],
      [
        1235.0,
        1030.0,
        120.0
      ],
      [
        1215.0,
        1030.0,
        120.0
      ],
      [
        1200.0,
        1082.0,
        120.0
      ],
      [
        1200.0,
        1120.0,
        120.0
      ],
      [
        1200.0,
        1120.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        118.0
      ],
      [
        1200.0,
        930.0,
        120.0
      ],
      [
        1186.0,
        1030.0,
        120.0
      ],
      [
        1186.0,
        1030.0,
        118.0
      ],
      [
        1200.0,
        1030.0,
        118.0
      ],
      [
        1200.0,
        1030.0,
        120.0
      ],
      [
        1200.0,
        1082.0,
        120.0
      ],
      [
        1210.0,
        1082.0,
        120.0
      ],
      [
        1210.0,
        1082.0,
        120.0
      ],
      [
        1200.0,
        867.8525390625,
        140.0
      ],
      [
        1200.0,
        825.0,
        140.0
      ],
      [
        1189.5999755859375,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1030.0,
        1110.0,
        130.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1030.0,
        1109.5999755859375,
        140.0
      ],
      [
        1186.0,
        1030.0,
        140.0
      ],
      [
        1190.4000244140625,
        1030.0,
        120.0
      ],
      [
        1189.599853515625,
        1030.0,
        140.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1189.199951171875,
        970.4000244140625,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1159.5999755859375,
        1109.199951171875,
        140.0
      ],
      [
        1189.199951171875,
        1079.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1050.4000244140625,
        1109.199951171875,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1163.3333740234375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.6666259765625,
        1113.3333740234375,
        140.0
      ],
      [
        1163.7333984375,
        1113.3333740234375,
        140.0
      ],
      [
        1046.2666015625,
        1113.3333740234375,
        140.0
      ],
      [
        1190.0,
        1120.0,
        130.0
      ],
      [
        1189.599853515625,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1120.0,
        130.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1030.0,
        1119.199951171875,
        140.0
      ],
      [
        1040.4000244140625,
        1119.199951171875,
        140.0
      ],
      [
        1169.5999755859375,
        1119.199951171875,
        140.0
      ],
      [
        1193.3333740234375,
        1083.3333740234375,
        140.0
      ],
      [
        1193.3333740234375,
        966.6666870117188,
        140.0
      ],
      [
        1200.0,
        1030.0,
        120.0
      ],
      [
        1200.0,
        1030.0,
        130.0
      ],
      [
        1193.3333740234375,
        1030.0,
        140.0
      ],
      [
        1193.33349609375,
        966.2665405273438,
        140.0
      ],
      [
        1193.33349609375,
        1083.7335205078125,
        140.0
      ],
      [
        1193.3333740234375,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        930.7999877929688,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        960.4000244140625,
        140.0
      ],
      [
        1199.199951171875,
        1030.0,
        140.0
      ],
      [
        1200.0,
        1030.0,
        140.0
      ],
      [
        1235.0,
        1030.0,
        140.0
      ],
      [
        1235.0,
        1035.0,
        138.0
      ],
      [
        1235.0,
        1055.0,
        138.0
      ],
      [
        1235.0,
        1035.0,
        138.0
      ],
      [
        1235.0,
        1035.0,
        140.0
      ],
      [
        1235.0,
        1055.0,
        138.0
      ],
      [
        1235.0,
        1055.0,
        140.0
      ],
      [
        1210.0,
        1058.0,
        138.0
      ],
      [
        1235.0,
        1120.0,
        100.0
      ],
      [
        1235.0,
        930.0,
        80.0
      ],
      [
        1186.0,
        1030.0,
        90.52631378173828
      ],
      [
        1235.0,
        1030.0,
        80.0
      ],
      [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      [
        1200.0,
        1030.0,
        90.52631378173828
      ],
      [
        1200.0,
        1030.0,
        118.0
      ],
      [
        1250.0,
        1030.0,
        90.52631378173828
      ],
      [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      [
        945.5584716796875,
        1310.0,
        76.55585479736328
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        945.5584716796875,
        1310.0,
        100.0
      ],
      [
        820.0,
        1400.0,
        100.0
      ],
      [
        871.1104736328125,
        1400.0,
        69.11104583740234
      ],
      [
        871.1104736328125,
        1400.0,
        100.0
      ],
      [
        980.0,
        1120.0,
        80.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1377.16455078125,
        100.0
      ],
      [
        890.0,
        1400.0,
        100.0
      ],
      [
        890.0,
        1377.16455078125,
        140.0
      ],
      [
        945.5584716796875,
        1310.0,
        140.0
      ],
      [
        871.1104736328125,
        1400.0,
        140.0
      ],
      [
        871.1104736328125,
        1400.0,
        100.0
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        980.0,
        1120.0,
        133.9837646484375
      ],
      [
        980.0,
        1143.07421875,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        990.0,
        1120.0,
        120.0
      ],
      [
        980.0,
        1120.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        980.0,
        1120.0,
        118.0
      ],
      [
        988.9999389648438,
        1120.0,
        118.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1000.0,
        1120.0,
        98.0
      ],
      [
        1000.0,
        1120.0,
        100.0
      ],
      [
        1020.0,
        1120.0,
        81.05262756347656
      ],
      [
        1020.0,
        1145.0,
        80.0
      ],
      [
        1020.0,
        1410.0,
        100.0
      ],
      [
        1020.0,
        1410.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        950.0,
        970.0,
        80.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        118.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        120.0
      ],
      [
        865.0,
        1100.0,
        120.0
      ],
      [
        865.0,
        1100.0,
        118.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        865.0,
        1100.0,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        480.0,
        1110.0,
        80.0
      ],
      [
        480.0,
        1110.0,
        120.0
      ],
      [
        480.0,
        1090.0,
        120.0
      ],
      [
        480.0,
        1110.0,
        120.0
      ],
      [
        760.0,
        1110.0,
        110.0
      ],
      [
        780.0,
        1110.0,
        110.0
      ],
      [
        700.0,
        1090.0,
        140.0
      ],
      [
        480.0,
        1090.0,
        140.0
      ],
      [
        480.0,
        1090.0,
        120.0
      ],
      [
        700.0,
        1000.0,
        140.0
      ],
      [
        700.0,
        1090.0,
        140.0
      ],
      [
        500.0,
        1170.0,
        80.0
      ],
      [
        500.0,
        1400.0,
        80.0
      ],
      [
        500.0,
        1400.0,
        78.0
      ],
      [
        500.0,
        1170.0,
        78.0
      ],
      [
        480.0,
        1400.0,
        80.0
      ],
      [
        500.0,
        1400.0,
        80.0
      ],
      [
        664.30078125,
        1384.3714599609375,
        80.0
      ],
      [
        440.0,
        1405.0,
        100.0
      ],
      [
        440.0,
        1090.0,
        140.0
      ],
      [
        440.0,
        1110.0,
        140.0
      ],
      [
        440.0,
        1405.0,
        100.0
      ],
      [
        400.0,
        1404.9998779296875,
        100.0
      ],
      [
        400.0,
        1415.9998779296875,
        78.0
      ],
      [
        403.9993896484375,
        1415.0,
        79.99970245361328
      ],
      [
        400.0,
        1405.0,
        100.0
      ],
      [
        400.0,
        1385.0,
        140.0
      ],
      [
        440.0,
        1404.9998779296875,
        100.0
      ],
      [
        460.0,
        1405.0,
        100.0
      ],
      [
        460.0,
        1404.9998779296875,
        100.0
      ],
      [
        460.0,
        1405.9998779296875,
        98.0
      ],
      [
        440.0,
        1110.0,
        100.0
      ],
      [
        460.0,
        1110.0,
        80.0
      ],
      [
        460.0,
        1110.0,
        100.0
      ],
      [
        440.0,
        1412.4998779296875,
        85.0
      ],
      [
        460.0,
        1406.0,
        98.0
      ],
      [
        480.0,
        1110.0,
        100.0
      ],
      [
        440.0,
        1090.0,
        140.0
      ],
      [
        440.0,
        1412.5,
        85.0
      ],
      [
        440.0,
        1415.0,
        85.0
      ],
      [
        444.0,
        1415.0,
        100.0
      ],
      [
        444.0,
        1417.0,
        100.0
      ],
      [
        519.3518676757812,
        1550.0,
        190.0
      ],
      [
        519.3518676757812,
        1550.0,
        150.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        370.0
      ],
      [
        1549.9998779296875,
        1550.0,
        140.0
      ],
      [
        1549.9998779296875,
        1550.0,
        500.0
      ],
      [
        1549.9998779296875,
        1550.0,
        1180.0
      ],
      [
        1488.300048828125,
        1630.0,
        177.0
      ],
      [
        1225.0,
        1630.0,
        270.0
      ],
      [
        1170.0,
        1630.0,
        230.0
      ],
      [
        1225.0,
        1630.0,
        329.0
      ],
      [
        1225.0,
        1630.0,
        270.0
      ],
      [
        1257.887939453125,
        1630.0,
        140.0
      ],
      [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      [
        1215.0,
        1630.0,
        157.38461303710938
      ],
      [
        1317.928955078125,
        1550.0,
        160.0
      ],
      [
        1292.071044921875,
        1550.0,
        160.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1350.0,
        1550.0,
        190.0
      ],
      [
        1350.0,
        1550.0,
        190.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1570.0,
        160.0
      ],
      [
        1290.0,
        1550.0,
        190.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1250.0,
        1550.0,
        140.0
      ],
      [
        1350.0,
        1550.0,
        153.5
      ],
      [
        1350.0,
        1550.0,
        140.0
      ],
      [
        1350.0,
        1550.0,
        160.0
      ],
      [
        1350.0,
        1550.0,
        153.5
      ],
      [
        1325.0,
        1550.0,
        145.44444274902344
      ],
      [
        1325.0,
        1550.0,
        149.07408142089844
      ],
      [
        1335.0,
        1550.0,
        145.44444274902344
      ],
      [
        1325.0,
        1550.0,
        145.44444274902344
      ],
      [
        1350.0,
        1550.0,
        145.44444274902344
      ],
      [
        1340.0,
        1550.0,
        145.44444274902344
      ],
      [
        1340.0,
        1550.0,
        145.44444274902344
      ],
      [
        1340.0,
        1550.0,
        149.07408142089844
      ],
      [
        1302.4774169921875,
        1550.0,
        143.0
      ],
      [
        1299.4774169921875,
        1550.0,
        143.0
      ],
      [
        1299.4774169921875,
        1550.0,
        143.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        370.0
      ],
      [
        1660.0,
        1469.9998779296875,
        140.0
      ],
      [
        1660.0,
        1469.9998779296875,
        500.0
      ],
      [
        1660.0,
        1469.9998779296875,
        1180.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        400.0
      ],
      [
        1735.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      [
        1680.0,
        1400.0,
        400.0
      ],
      [
        1748.13330078125,
        1420.0,
        178.933349609375
      ],
      [
        1748.13330078125,
        1410.0,
        178.933349609375
      ],
      [
        1748.13330078125,
        1410.0,
        178.933349609375
      ],
      [
        1680.0,
        1400.0,
        400.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1750.0,
        1220.0,
        180.0
      ],
      [
        1750.0,
        1235.0,
        140.0
      ],
      [
        1750.0,
        1235.0,
        160.0
      ],
      [
        1710.0,
        1235.0,
        140.0
      ],
      [
        1690.0001220703125,
        1360.0,
        220.0
      ],
      [
        1690.0001220703125,
        1330.0,
        220.0
      ],
      [
        1690.0001220703125,
        1280.0,
        220.0
      ],
      [
        1690.0001220703125,
        1250.0,
        220.0
      ],
      [
        1690.0001220703125,
        1280.0,
        220.0
      ],
      [
        1690.0001220703125,
        1330.0,
        220.0
      ],
      [
        1690.0001220703125,
        1360.0,
        220.0
      ],
      [
        1680.0,
        810.0,
        240.0
      ],
      [
        1660.0,
        810.0,
        240.0
      ],
      [
        1660.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        810.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1660.0,
        840.0,
        220.0
      ],
      [
        1660.0,
        840.0,
        140.0
      ],
      [
        1680.0,
        840.0,
        140.0
      ],
      [
        1660.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        840.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        220.0
      ],
      [
        1660.0,
        900.0,
        220.0
      ],
      [
        1660.0,
        900.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        220.0
      ],
      [
        1680.0,
        900.0,
        240.0
      ],
      [
        1660.0,
        900.0,
        240.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1700.0,
        1210.0,
        140.0
      ],
      [
        1700.0,
        982.5,
        310.0
      ],
      [
        1700.0,
        982.5,
        140.0
      ],
      [
        1766.0001220703125,
        900.0,
        220.0
      ],
      [
        1766.0001220703125,
        900.0,
        240.0
      ],
      [
        1770.0,
        895.0001220703125,
        220.0
      ],
      [
        1766.0001220703125,
        900.0,
        220.0
      ],
      [
        1700.0,
        1210.0,
        310.0
      ],
      [
        1700.0,
        810.0,
        240.0
      ],
      [
        1700.0,
        810.0,
        140.0
      ],
      [
        1700.0,
        700.0,
        258.0
      ],
      [
        1700.0,
        700.0,
        338.0
      ],
      [
        1700.0,
        840.0,
        220.0
      ],
      [
        1700.0,
        840.0,
        140.0
      ],
      [
        1700.0,
        840.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        220.0
      ],
      [
        1700.0,
        900.0,
        240.0
      ],
      [
        1690.0,
        810.0,
        240.0
      ],
      [
        1690.0,
        810.0,
        140.0
      ],
      [
        1690.0,
        700.0,
        258.0
      ],
      [
        1700.0,
        700.0,
        325.00006103515625
      ],
      [
        1690.0,
        700.0,
        309.99993896484375
      ],
      [
        1690.0,
        840.0,
        220.0
      ],
      [
        1690.0,
        840.0,
        140.0
      ],
      [
        1690.0,
        840.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        240.0
      ],
      [
        1690.0,
        700.0,
        338.0
      ],
      [
        1400.0,
        1469.9998779296875,
        190.0
      ],
      [
        1400.0,
        1469.9998779296875,
        210.0
      ],
      [
        1400.0,
        1469.9998779296875,
        190.0
      ],
      [
        1400.0,
        1469.9998779296875,
        160.0
      ],
      [
        1365.0,
        1469.9998779296875,
        210.0
      ],
      [
        1400.0,
        1469.9998779296875,
        210.0
      ],
      [
        1350.0,
        1507.0,
        188.0
      ],
      [
        1350.0,
        1510.0,
        188.0
      ],
      [
        1350.0,
        1527.0,
        188.0
      ],
      [
        1350.0,
        1530.0,
        188.0
      ],
      [
        1350.0,
        1547.0,
        188.0
      ],
      [
        1350.0,
        1550.0,
        188.0
      ],
      [
        1350.0,
        1547.0,
        188.0
      ],
      [
        1350.0,
        1507.0,
        188.0
      ],
      [
        1350.0,
        1527.0,
        188.0
      ],
      [
        1350.0,
        1527.0,
        200.0
      ],
      [
        1371.0,
        1527.0,
        200.0
      ],
      [
        1350.0,
        1527.0,
        190.0
      ],
      [
        1371.0,
        1527.0,
        190.0
      ],
      [
        1371.0,
        1527.0,
        200.0
      ],
      [
        1371.0,
        1527.0,
        190.0
      ],
      [
        1400.0,
        1370.0,
        340.0
      ],
      [
        1400.0,
        1370.0,
        360.0
      ],
      [
        1400.0,
        1370.0,
        340.0
      ],
      [
        1400.0,
        1370.0,
        310.0
      ],
      [
        1400.0,
        1370.0,
        360.0
      ],
      [
        1400.0,
        1370.0,
        390.0
      ],
      [
        1400.0,
        1370.0,
        290.0
      ],
      [
        1400.0,
        1370.0,
        310.0
      ],
      [
        1400.0,
        1370.0,
        410.0
      ],
      [
        1400.0,
        1370.0,
        390.0
      ],
      [
        1400.0,
        1370.0,
        290.0
      ],
      [
        1400.0,
        1370.0,
        140.0
      ],
      [
        1400.0,
        1370.0,
        410.0
      ],
      [
        1400.0,
        1370.0,
        601.1122436523438
      ],
      [
        1400.0,
        1343.07177734375,
        390.0
      ],
      [
        1400.0,
        1343.07177734375,
        410.0
      ],
      [
        1400.0,
        1314.78759765625,
        390.0
      ],
      [
        1400.0,
        1343.07177734375,
        390.0
      ],
      [
        1400.0,
        1314.78759765625,
        410.0
      ],
      [
        1400.0,
        1314.78759765625,
        390.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        714.611572265625,
        1270.0,
        520.0
      ],
      [
        714.611572265625,
        1270.0,
        550.0
      ],
      [
        717.8607788085938,
        1280.0,
        550.0
      ],
      [
        1200.0,
        1270.0,
        260.0
      ],
      [
        1030.0,
        1270.0,
        260.0
      ],
      [
        1200.0,
        1270.0,
        260.0
      ],
      [
        1200.0,
        1270.0,
        140.0
      ],
      [
        1000.0,
        1270.0,
        140.0
      ],
      [
        1000.0,
        1270.0,
        260.0
      ],
      [
        1000.0,
        1280.0,
        260.0
      ],
      [
        1030.0,
        1270.0,
        400.0
      ],
      [
        1030.0,
        1270.0,
        300.0
      ],
      [
        1000.0,
        1270.0,
        280.0
      ],
      [
        1030.0,
        1270.0,
        300.0
      ],
      [
        1000.0,
        1270.0,
        280.0
      ],
      [
        1250.0,
        1460.0,
        140.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1350.0,
        1460.0,
        190.0
      ],
      [
        1350.0,
        1460.0,
        190.0
      ],
      [
        1290.0,
        1460.0,
        190.0
      ],
      [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      [
        1030.0,
        1310.0,
        355.9431457519531
      ],
      [
        1030.0,
        1310.0,
        515.0
      ],
      [
        1030.0,
        1380.0,
        515.0
      ],
      [
        1175.0,
        1380.0,
        515.0
      ],
      [
        1175.0,
        1310.0,
        515.0
      ],
      [
        1200.0,
        1380.0,
        515.0
      ],
      [
        1200.0,
        1310.0,
        515.0
      ],
      [
        1030.0,
        1300.0,
        180.0
      ],
      [
        1030.0,
        1280.0,
        180.0
      ],
      [
        890.0,
        1460.0,
        140.0
      ],
      [
        890.0,
        1460.0,
        180.0
      ],
      [
        1266.0,
        1460.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1550.0,
        160.0
      ],
      [
        1266.0,
        1460.0,
        160.0
      ],
      [
        1266.0,
        1527.0,
        160.0
      ],
      [
        1268.5347900390625,
        1527.0,
        160.0
      ],
      [
        1266.0,
        1547.0,
        160.0
      ],
      [
        1268.5347900390625,
        1547.0,
        160.0
      ],
      [
        1268.5347900390625,
        1550.0,
        160.0
      ],
      [
        1268.5347900390625,
        1547.0,
        160.0
      ],
      [
        1268.5347900390625,
        1527.0,
        160.0
      ],
      [
        1268.5347900390625,
        1530.0,
        160.0
      ],
      [
        1335.0,
        1531.2857666015625,
        160.0
      ],
      [
        1325.0,
        1531.2857666015625,
        160.0
      ],
      [
        1350.0,
        1531.2857666015625,
        160.0
      ],
      [
        1340.0,
        1531.2857666015625,
        160.0
      ],
      [
        1325.0,
        1531.2857666015625,
        160.0
      ],
      [
        1325.0,
        1536.279052734375,
        160.0
      ],
      [
        1340.0,
        1531.2857666015625,
        160.0
      ],
      [
        1340.0,
        1536.279052734375,
        160.0
      ],
      [
        1266.0,
        1507.0,
        160.0
      ],
      [
        1268.5347900390625,
        1507.0,
        160.0
      ],
      [
        1268.5347900390625,
        1507.0,
        160.0
      ],
      [
        1268.5347900390625,
        1510.0,
        160.0
      ],
      [
        1291.24267578125,
        1507.0,
        165.0
      ],
      [
        1291.24267578125,
        1507.0,
        160.0
      ],
      [
        1318.75732421875,
        1507.0,
        165.0
      ],
      [
        1318.75732421875,
        1507.0,
        160.0
      ],
      [
        1266.0,
        1487.0,
        160.0
      ],
      [
        1268.5347900390625,
        1487.0,
        160.0
      ],
      [
        1268.5347900390625,
        1487.0,
        160.0
      ],
      [
        1268.5347900390625,
        1490.0,
        160.0
      ],
      [
        1307.3125,
        1487.0,
        165.0
      ],
      [
        1307.3125,
        1487.0,
        160.0
      ],
      [
        1307.0,
        1550.0,
        145.44447326660156
      ],
      [
        1305.2725830078125,
        1547.622314453125,
        147.29376220703125
      ],
      [
        1305.2725830078125,
        1547.622314453125,
        147.29376220703125
      ],
      [
        1302.4774169921875,
        1548.530517578125,
        146.58734130859375
      ],
      [
        1256.2222900390625,
        1547.0,
        147.77781677246094
      ],
      [
        1265.851806640625,
        1547.0,
        147.77781677246094
      ],
      [
        1265.851806640625,
        1547.0,
        147.77781677246094
      ],
      [
        1267.0963134765625,
        1550.0,
        145.44444274902344
      ],
      [
        1305.5469970703125,
        1507.0,
        143.0
      ],
      [
        1309.255126953125,
        1507.0,
        143.0
      ],
      [
        1299.4774169921875,
        1507.0,
        143.0
      ],
      [
        1301.7471923828125,
        1507.0,
        143.0
      ],
      [
        1304.1102294921875,
        1507.0,
        143.0
      ],
      [
        1301.7471923828125,
        1507.0,
        143.0
      ],
      [
        1309.255126953125,
        1507.0,
        143.0
      ],
      [
        1299.4774169921875,
        1507.0,
        143.0
      ],
      [
        1294.92822265625,
        1478.0,
        140.0
      ],
      [
        1293.5621337890625,
        1478.0,
        144.0
      ],
      [
        890.0,
        1470.0,
        140.0
      ],
      [
        890.0,
        1470.0,
        180.0
      ],
      [
        1530.0,
        1130.0,
        465.0
      ],
      [
        1530.0,
        1130.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        140.0
      ],
      [
        1555.0,
        1120.0,
        465.0
      ],
      [
        1615.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        140.0
      ],
      [
        1530.0,
        1120.0,
        465.0
      ],
      [
        1530.0,
        1130.0,
        465.0
      ],
      [
        1535.0,
        1120.0,
        465.0
      ],
      [
        1605.0001220703125,
        1030.0,
        465.0
      ],
      [
        1565.0,
        1030.0,
        465.0
      ],
      [
        1556.0,
        1120.0,
        465.0
      ],
      [
        1614.0,
        1120.0,
        465.0
      ],
      [
        1530.0,
        1030.0,
        465.0
      ],
      [
        1475.0,
        1120.0,
        465.0
      ],
      [
        1530.0,
        1120.0,
        465.0
      ],
      [
        1475.0,
        880.0,
        170.0
      ],
      [
        1475.0,
        880.0,
        180.0
      ],
      [
        1475.0,
        880.0,
        170.0
      ],
      [
        1475.0,
        880.0,
        140.0
      ],
      [
        1475.0,
        880.0,
        350.0
      ],
      [
        1475.0,
        880.0,
        180.0
      ],
      [
        1525.0001220703125,
        1030.0,
        465.0
      ],
      [
        1484.9998779296875,
        1030.0,
        465.0
      ],
      [
        1476.0,
        1120.0,
        465.0
      ],
      [
        1530.0,
        1079.9991455078125,
        465.0
      ],
      [
        1395.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        140.0
      ],
      [
        1395.0,
        1120.0,
        465.0
      ],
      [
        1455.0,
        1120.0,
        465.0
      ],
      [
        1240.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        260.10211181640625
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1390.0,
        1120.0,
        160.0
      ],
      [
        1240.0,
        1120.0,
        160.0
      ],
      [
        1250.0,
        960.0,
        140.0
      ],
      [
        1240.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        161.1999969482422
      ],
      [
        1445.0001220703125,
        1030.0,
        465.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1396.0,
        1120.0,
        465.0
      ],
      [
        1454.0,
        1120.0,
        465.0
      ],
      [
        1250.0,
        1040.0,
        140.0
      ],
      [
        1380.0,
        1040.0,
        140.0
      ],
      [
        1240.0,
        1030.0,
        204.0
      ],
      [
        1240.0,
        1030.0,
        160.0001220703125
      ],
      [
        1250.0,
        1030.0,
        140.0
      ],
      [
        1240.0,
        1030.0,
        140.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1250.0,
        1050.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        260.0
      ],
      [
        1000.0,
        1270.0,
        260.0
      ],
      [
        1030.0,
        1170.0,
        400.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      [
        1189.5999755859375,
        950.0,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1050.0,
        1109.5999755859375,
        140.0
      ],
      [
        1160.0,
        1109.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        970.0000610351562,
        140.0
      ],
      [
        1187.0400390625,
        1030.0,
        204.0
      ],
      [
        1189.5999755859375,
        1030.0,
        140.0
      ],
      [
        1173.0,
        1091.9998779296875,
        580.0
      ],
      [
        1199.199951171875,
        1109.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        950.0,
        140.0
      ],
      [
        1189.3616943359375,
        1030.0,
        145.95767211914062
      ],
      [
        1193.33349609375,
        1030.0,
        140.0
      ],
      [
        1194.0799560546875,
        1030.0,
        204.0
      ],
      [
        1199.199951171875,
        1030.0,
        140.0
      ],
      [
        868.6692504882812,
        1120.0,
        600.0
      ],
      [
        868.669189453125,
        1120.0,
        170.0
      ],
      [
        868.6692504882812,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        865.0,
        1120.0,
        170.0
      ],
      [
        861.330810546875,
        1120.0,
        170.0
      ],
      [
        480.0,
        1110.0,
        160.0
      ],
      [
        480.0,
        1110.0,
        190.0
      ],
      [
        480.0,
        1110.0,
        160.0
      ],
      [
        480.0,
        1090.0,
        160.0
      ],
      [
        895.006103515625,
        1110.0,
        170.0
      ],
      [
        865.0,
        1110.0,
        170.0
      ],
      [
        865.0,
        1110.0,
        170.0
      ],
      [
        834.9939575195312,
        1110.0,
        170.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        160.0
      ],
      [
        865.0,
        1100.0,
        160.0
      ],
      [
        480.0,
        1090.0,
        160.0
      ],
      [
        480.0,
        1090.0,
        140.0
      ],
      [
        891.3368530273438,
        1090.0,
        160.0
      ],
      [
        891.3368530273438,
        1090.0,
        140.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        140.185791015625,
        4934.54296875,
        -300.0
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        140.185791015625,
        4934.54296875,
        -300.0
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004390379413962364,
        -0.9486730098724365,
        0.31622809171676636
      ],
      "plane_d": 4789.4853515625,
      "bbox_min": [
        140.185791015625,
        4934.54296875,
        -300.0
      ],
      "bbox_max": [
        3045.157470703125,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        183.38438415527344,
        5034.5224609375,
        -36.837890625
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        816.3760375976562,
        6871.484375,
        547.115966796875
      ],
      "bbox_max": [
        3108.39404296875,
        7327.39501953125,
        652.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        183.38438415527344,
        6871.484375,
        623.0784912109375
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        183.38438415527344,
        7446.69482421875,
        679.593505859375
      ],
      "bbox_max": [
        200.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        4955.25732421875,
        -22.699951171875
      ],
      "bbox_max": [
        183.38442993164062,
        7446.69482421875,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8558866381645203,
        -0.018606234341859818,
        0.5168285369873047
      ],
      "plane_d": 228.558349609375,
      "bbox_min": [
        -750.0,
        4955.25732421875,
        150.0
      ],
      "bbox_max": [
        -202.00167846679688,
        7158.4658203125,
        1050.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7596201300621033,
        0.64952552318573,
        -0.03307165205478668
      ],
      "plane_d": 2160.664794921875,
      "bbox_min": [
        -825.0,
        -3700.0,
        0.0
      ],
      "bbox_max": [
        400.0,
        -2275.0,
        1852.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 1667.7852783203125,
      "bbox_min": [
        1658.0,
        2862.0,
        -300.0
      ],
      "bbox_max": [
        1910.0,
        3166.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9478254914283752,
        -0.04033299908041954,
        0.3162277936935425
      ],
      "plane_d": 1918.842529296875,
      "bbox_min": [
        1789.6541748046875,
        2960.0,
        -300.0
      ],
      "bbox_max": [
        1910.0,
        3166.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.981298565864563,
        -0.041757386177778244,
        0.18790823221206665
      ],
      "plane_d": 1986.607666015625,
      "bbox_min": [
        1894.0,
        2960.0,
        0.0
      ],
      "bbox_max": [
        1910.0,
        3066.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6543579101562,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        329.84539794921875
      ],
      "bbox_max": [
        7550.0,
        -1319.93994140625,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1700.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        590.90966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1390.916015625,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        -796.68505859375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2300.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        -796.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161503076553345
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        650.0,
        -1150.0,
        0.0
      ],
      "bbox_max": [
        2400.0,
        -796.68505859375,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        523.75537109375,
        -1600.0,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161503076553345
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        523.75537109375,
        -867.0938720703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        16.99639320373535
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        -309.5032958984375,
        490.0,
        59.99999237060547
      ],
      "bbox_max": [
        2110.0,
        2080.0,
        1180.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1100.0,
        1689.9998779296875,
        119.99995422363281
      ],
      "bbox_max": [
        2020.0,
        2080.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        2050.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1910.0,
        1888.11865234375,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1888.11865234375,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1896.0001220703125,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1940.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1876.693359375,
        1060.0
      ],
      "bbox_max": [
        1917.3709716796875,
        1895.489501953125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.045654296875,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1814.6104736328125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1704.19970703125,
        1865.1998291015625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1704.5103759765625,
        1830.0,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1106.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.25882136821746826,
        -0.9659252762794495,
        6.868348805255664e-07
      ],
      "plane_d": 1310.7298583984375,
      "bbox_min": [
        1794.9998779296875,
        1837.9422607421875,
        1060.0
      ],
      "bbox_max": [
        1840.000244140625,
        1850.0001220703125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1909.74462890625,
        1895.74462890625,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1550.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        2011.0,
        2050.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.71764951221121e-07,
        0.0
      ],
      "plane_d": 1549.998779296875,
      "bbox_min": [
        1550.0,
        1830.0,
        140.0
      ],
      "bbox_max": [
        1550.0001220703125,
        2011.7158203125,
        980.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        2011.0,
        2050.0,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1865.199951171875,
        500.0
      ],
      "bbox_max": [
        2011.0,
        1940.0999755859375,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        -0.0
      ],
      "plane_d": 2353.7021484375,
      "bbox_min": [
        1910.0,
        1931.0999755859375,
        500.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1940.0999755859375,
        980.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0,
        1830.0,
        119.99995422363281
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        9.765615232026903e-07,
        -1.0,
        0.0
      ],
      "plane_d": 1964.9984130859375,
      "bbox_min": [
        1655.0,
        1855.0,
        119.99995422363281
      ],
      "bbox_max": [
        1780.0001220703125,
        1965.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -3.9238043427758384e-06,
        -0.515036940574646,
        -0.8571680784225464
      ],
      "plane_d": 1103.7305908203125,
      "bbox_min": [
        1655.0,
        1855.0,
        119.99995422363281
      ],
      "bbox_max": [
        1680.0001220703125,
        1943.2857666015625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -1.220703143189894e-05,
        0.0
      ],
      "plane_d": 1680.022705078125,
      "bbox_min": [
        1680.0,
        1855.0,
        120.0
      ],
      "bbox_max": [
        1680.0001220703125,
        1910.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1659.9984130859375,
      "bbox_min": [
        1658.9056396484375,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1660.0,
        1760.0,
        1130.0
      ],
      "bbox_max": [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.045654296875,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1829.844482421875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.355224609375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.6669921875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1130.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1100.0,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1830.0001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1100.0,
        1689.9998779296875,
        230.0
      ],
      "bbox_max": [
        1655.0,
        1830.0001220703125,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        8.719300694792764e-07,
        0.0
      ],
      "plane_d": 1549.9984130859375,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        350.0
      ],
      "bbox_max": [
        1550.0,
        1830.0,
        390.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        1100.0,
        1690.0,
        230.0
      ],
      "bbox_max": [
        1585.0001220703125,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1690.0,
        230.0
      ],
      "bbox_max": [
        1585.0001220703125,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1225.0,
        1690.0,
        270.0
      ],
      "bbox_max": [
        1225.0,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.662087237898959e-06,
        -0.6000000238418579,
        -0.8000000715255737
      ],
      "plane_d": 1353.9942626953125,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1585.0001220703125,
        1830.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1565.0,
      "bbox_min": [
        1565.0,
        1790.0,
        320.0
      ],
      "bbox_max": [
        1565.0,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.324115813389653e-06,
        0.5999988913536072,
        -0.8000009655952454
      ],
      "plane_d": -757.9862060546875,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1585.0001220703125,
        1730.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -3.0517671802954283e-06,
        0.0
      ],
      "plane_d": 1565.005126953125,
      "bbox_min": [
        1564.9998779296875,
        1690.0,
        320.0
      ],
      "bbox_max": [
        1565.0,
        1729.9998779296875,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1655.0,
        1689.9998779296875,
        120.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1830.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1830.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0001220703125,
        1690.0,
        120.0
      ],
      "bbox_max": [
        1746.4769287109375,
        1815.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1815.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1705.0,
      "bbox_min": [
        1680.0,
        1705.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1705.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1480.0,
        490.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        522.5,
        338.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1659.9998779296875,
      "bbox_min": [
        1660.0,
        538.75,
        338.0
      ],
      "bbox_max": [
        1660.0,
        560.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        490.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        560.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        -309.5032958984375,
        560.0,
        59.99999237060547
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -309.5032958984375,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        110.0,
        1490.0,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        8.239746966864914e-05
      ],
      "plane_d": 309.45880126953125,
      "bbox_min": [
        -309.5032958984375,
        971.800048828125,
        500.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8289903998374939,
        -0.5592629313468933,
        4.0998944314196706e-05
      ],
      "plane_d": 844.7847900390625,
      "bbox_min": [
        -309.5032958984375,
        1051.798095703125,
        500.0
      ],
      "bbox_max": [
        -293.78204345703125,
        1075.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        260.0,
        560.0,
        59.99999237060547
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        260.0,
        560.0,
        59.99999237060547
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1905.0,
        560.0,
        144.0
      ],
      "bbox_max": [
        1910.0,
        670.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1905.0,
      "bbox_min": [
        1905.0,
        650.0,
        144.0
      ],
      "bbox_max": [
        1905.0,
        670.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -630.0,
      "bbox_min": [
        1360.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        560.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        630.0,
        338.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1480.0,
        590.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        630.0,
        90.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1480.0,
        610.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        610.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1522.5999755859375,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5734623670578003,
        0.0,
        -0.8192319273948669
      ],
      "plane_d": -594.7623901367188,
      "bbox_min": [
        1480.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1490.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1522.5999755859375,
        560.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        630.0,
        348.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1659.9998779296875,
      "bbox_min": [
        1640.0,
        560.0,
        338.0
      ],
      "bbox_max": [
        1660.0,
        630.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        560.0,
        338.0
      ],
      "bbox_max": [
        1640.0,
        630.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1522.5999755859375,
        590.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        1522.5999755859375,
        610.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1522.5999755859375,
        610.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        85.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1334.9326171875,
      "bbox_min": [
        1532.5,
        628.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        630.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 317.0,
      "bbox_min": [
        1522.5999755859375,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5734623670578003,
        -0.0,
        -0.8192319273948669
      ],
      "plane_d": 1154.2978515625,
      "bbox_min": [
        1560.0,
        600.0,
        310.0
      ],
      "bbox_max": [
        1570.0,
        630.0,
        317.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1480.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        670.0,
        338.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        630.0,
        80.0
      ],
      "bbox_max": [
        1522.5999755859375,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": 501.45062255859375,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9574458599090576,
        0.28861290216445923,
        0.0
      ],
      "plane_d": 1235.1937255859375,
      "bbox_min": [
        1480.0,
        630.0,
        120.0
      ],
      "bbox_max": [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2316918820142746,
        0.9727892875671387,
        0.0
      ],
      "plane_d": -298.43865966796875,
      "bbox_min": [
        1502.5,
        664.64111328125,
        120.0
      ],
      "bbox_max": [
        1522.5999755859375,
        669.4284057617188,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1522.5999755859375,
        630.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1522.5999755859375,
        630.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1659.9998779296875,
      "bbox_min": [
        1640.0,
        630.0,
        338.0
      ],
      "bbox_max": [
        1660.0,
        650.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        630.0,
        338.0
      ],
      "bbox_max": [
        1640.0,
        650.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1522.5999755859375,
        630.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        650.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1522.5999755859375,
        630.0,
        160.0
      ],
      "bbox_max": [
        1570.0,
        650.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1522.5999755859375,
        650.0,
        80.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1640.0,
      "bbox_min": [
        1640.0,
        650.0,
        258.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1659.9998779296875,
      "bbox_min": [
        1660.0,
        650.0,
        338.0
      ],
      "bbox_max": [
        1660.0,
        670.0,
        348.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1522.5999755859375,
        650.0,
        80.0
      ],
      "bbox_max": [
        1570.0,
        670.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2316918820142746,
        0.9727892875671387,
        -0.0
      ],
      "plane_d": -1005.098876953125,
      "bbox_min": [
        1522.5999755859375,
        650.0,
        120.0
      ],
      "bbox_max": [
        1563.97119140625,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6643652319908142,
        0.7474080920219421,
        0.0
      ],
      "plane_d": -1524.86328125,
      "bbox_min": [
        1522.5999755859375,
        650.0,
        120.0
      ],
      "bbox_max": [
        1563.97119140625,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2316918820142746,
        0.9727892875671387,
        0.0
      ],
      "plane_d": -298.43865966796875,
      "bbox_min": [
        1522.5999755859375,
        669.4284057617188,
        120.0
      ],
      "bbox_max": [
        1525.0,
        670.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1769.9998779296875,
      "bbox_min": [
        260.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        2110.0,
        1690.0,
        1180.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1769.9998779296875,
        670.0,
        120.0
      ],
      "bbox_max": [
        2110.0,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1643.306640625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 350.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1579.9000244140625,
      "bbox_min": [
        1770.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1840.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1666.4769287109375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5999988913536072,
        -0.0,
        -0.8000009655952454
      ],
      "plane_d": 1401.998291015625,
      "bbox_min": [
        1870.0,
        1485.0,
        320.0
      ],
      "bbox_max": [
        1910.0001220703125,
        1505.0001220703125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        1870.0,
        1485.0,
        320.0
      ],
      "bbox_max": [
        1910.0,
        1485.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1770.0,
        1469.9998779296875,
        120.0
      ],
      "bbox_max": [
        1814.0194091796875,
        1666.4769287109375,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1789.3779296875,
        1469.9998779296875,
        135.0
      ],
      "bbox_max": [
        1814.019287109375,
        1485.6220703125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1770.0,
        670.0,
        120.0
      ],
      "bbox_max": [
        1910.0,
        1469.9998779296875,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1770.0,
        700.0,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1469.9998779296875,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1770.0,
        760.0,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1469.9998779296875,
        149.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        1770.0,
        760.0,
        144.0
      ],
      "bbox_max": [
        1775.0,
        760.0,
        149.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1770.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1469.9998779296875,
        135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 2103.508056640625,
      "bbox_min": [
        1770.0,
        1402.94091796875,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": 1365.867431640625,
      "bbox_min": [
        1795.8818359375,
        1425.0,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": 250.84375,
      "bbox_min": [
        1801.7926025390625,
        1447.05908203125,
        120.0
      ],
      "bbox_max": [
        1817.94091796875,
        1463.20751953125,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1770.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1776.69873046875,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1629.9998779296875,
      "bbox_min": [
        260.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1630.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1655.0,
      "bbox_min": [
        1630.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1655.0,
        1470.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1655.0001220703125,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1650.0,
        1450.0,
        135.0
      ],
      "bbox_max": [
        1653.0001220703125,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 940.4520874023438,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1665.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1665.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1655.0,
        1468.0,
        135.0
      ],
      "bbox_max": [
        1770.0,
        1665.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1468.0,
        135.0
      ],
      "bbox_max": [
        1770.0,
        1655.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1655.0,
        135.0
      ],
      "bbox_max": [
        1690.0,
        1655.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1765.0001220703125,
        1468.0,
        138.0
      ],
      "bbox_max": [
        1770.0,
        1470.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1655.0,
        1468.0,
        138.0
      ],
      "bbox_max": [
        1670.0,
        1470.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -2.0345094071672065e-06,
        0.0
      ],
      "plane_d": 1695.0030517578125,
      "bbox_min": [
        1680.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1665.0,
        135.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1665.0,
        135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1680.0,
        1610.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1655.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1655.0,
      "bbox_min": [
        1680.0,
        1655.0,
        120.0
      ],
      "bbox_max": [
        1690.0,
        1655.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1468.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1655.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.425347353593679e-06,
        2.7126736767968396e-06
      ],
      "plane_d": 1694.9918212890625,
      "bbox_min": [
        1695.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1695.0001220703125,
        1465.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1650.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1450.0001220703125,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1660.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1697.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1680.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1683.5,
        1410.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1653.0001220703125,
        1440.0001220703125,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1441.0001220703125,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.8944272398948669,
        -0.44721361994743347
      ],
      "plane_d": 1350.5850830078125,
      "bbox_min": [
        1650.0,
        1441.0,
        120.0
      ],
      "bbox_max": [
        1700.0001220703125,
        1450.0001220703125,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1650.0,
        1441.0001220703125,
        120.0
      ],
      "bbox_max": [
        1695.0,
        1450.0001220703125,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070988416671753,
        -2.8772044515790185e-06,
        0.7071146368980408
      ],
      "plane_d": 1071.2567138671875,
      "bbox_min": [
        1650.0,
        1441.0001220703125,
        135.0
      ],
      "bbox_max": [
        1653.0001220703125,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1650.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        5.425347353593679e-06,
        2.7126736767968396e-06
      ],
      "plane_d": 1694.9918212890625,
      "bbox_min": [
        1695.0,
        1442.5,
        120.0
      ],
      "bbox_max": [
        1695.0,
        1450.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1630.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1630.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1680.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1630.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        1649.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1630.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        1639.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1630.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1630.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1630.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        1660.0,
        867.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.0,
      "bbox_min": [
        1660.0,
        887.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        887.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1651.6676025390625,
      "bbox_min": [
        1667.5,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1667.5,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": -1588.6082763671875,
      "bbox_min": [
        1670.0,
        877.5,
        130.0
      ],
      "bbox_max": [
        1672.5,
        882.5,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1630.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1630.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1630.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1650.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1630.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        940.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.08662962168455124,
        0.9962406754493713
      ],
      "plane_d": 1.7325897216796875,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        1026.25,
        87.49999237060547
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1630.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1680.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1630.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1050.0,
      "bbox_min": [
        1630.0,
        1050.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1657.0,
        1140.0,
        138.0
      ],
      "bbox_max": [
        1660.0,
        1140.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1650.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        138.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        133.3333282470703
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        960.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1150.0,
        118.0
      ],
      "bbox_max": [
        1633.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1150.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1630.0,
        1140.0,
        120.0
      ],
      "bbox_max": [
        1650.0,
        1140.0,
        133.3333282470703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1630.0,
        1026.25,
        87.49999237060547
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1650.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1650.0,
        960.0,
        87.49999237060547
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1650.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1680.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1660.0,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1650.0,
        990.0,
        120.0
      ],
      "bbox_max": [
        1660.0,
        993.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -805.9794921875,
      "bbox_min": [
        1650.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 804.3154296875,
      "bbox_min": [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1650.0,
        1140.0,
        131.3333282470703
      ],
      "bbox_max": [
        1660.0,
        1150.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1650.0,
        990.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1650.0,
        993.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1650.0,
        1000.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1680.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1680.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1770.0,
        920.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        840.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        810.0,
        120.0
      ],
      "bbox_max": [
        1750.0,
        810.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1690.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1690.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1700.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1941.239990234375,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1750.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1220.0,
      "bbox_min": [
        1690.0,
        957.5001220703125,
        98.0
      ],
      "bbox_max": [
        1750.0,
        1220.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1690.0,
        957.5001220703125,
        98.0
      ],
      "bbox_max": [
        1720.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        957.5001220703125,
        98.0
      ],
      "bbox_max": [
        1720.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1718.0001220703125,
        957.5001220703125,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1718.0001220703125,
        957.5001220703125,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1718.0001220703125,
        957.5001220703125,
        100.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6666666269302368,
        0.6666666269302368,
        0.3333333134651184
      ],
      "plane_d": 286.6666259765625,
      "bbox_min": [
        1690.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1710.0,
        1220.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1690.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1718.0001220703125,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1457.91650390625,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6666666269302368,
        0.6666666269302368,
        0.3333333134651184
      ],
      "plane_d": 286.6666259765625,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        119.99980163574219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -339.41131591796875,
      "bbox_min": [
        1680.0,
        1200.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        134.40017700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1210.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1680.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1680.0,
        940.0,
        118.0
      ],
      "bbox_max": [
        1690.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1680.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1680.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1680.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        260.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 997.0205688476562,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1690.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.500001847743988,
        -0.500001847743988,
        0.7071040868759155
      ],
      "plane_d": 1430.153076171875,
      "bbox_min": [
        1547.9998779296875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1508.2841796875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1587.455810546875,
        1467.9998779296875,
        138.0
      ],
      "bbox_max": [
        1630.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1507.455810546875,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2938015743202413e-06,
        -0.7071091532707214,
        0.7071043252944946
      ],
      "plane_d": 940.4536743164062,
      "bbox_min": [
        1580.0,
        1450.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1468.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1530.0,
        1450.0,
        138.0
      ],
      "bbox_max": [
        1548.0,
        1690.0,
        138.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1530.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": 812.1399536132812,
      "bbox_min": [
        1530.0,
        1440.0,
        120.0
      ],
      "bbox_max": [
        1576.0,
        1450.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1530.0,
        1440.0,
        138.0
      ],
      "bbox_max": [
        1540.0,
        1450.0,
        138.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1530.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        1170.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1530.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1617.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1617.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1620.0,
        1160.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        0.0,
        0.8320503234863281
      ],
      "plane_d": 798.7683715820312,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1590.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1620.0,
        1170.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1599.0,
      "bbox_min": [
        1599.0,
        1160.0,
        104.00003051757812
      ],
      "bbox_max": [
        1599.0,
        1170.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1599.0,
      "bbox_min": [
        1599.0,
        1160.0,
        100.0
      ],
      "bbox_max": [
        1599.0,
        1170.0,
        104.00003051757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        1615.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1534.9998779296875,
      "bbox_min": [
        1535.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        1615.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1615.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1534.9998779296875,
      "bbox_min": [
        1535.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1535.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1535.0,
      "bbox_min": [
        1535.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        1555.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1555.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1630.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1630.0,
        700.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4819187819957733,
        0.0,
        0.876215934753418
      ],
      "plane_d": -809.8425903320312,
      "bbox_min": [
        1535.0,
        670.0,
        59.99999237060547
      ],
      "bbox_max": [
        1571.3636474609375,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1530.0,
        725.0,
        80.0
      ],
      "bbox_max": [
        1535.0,
        725.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1530.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        920.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1530.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        890.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1530.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1530.0,
        725.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -138.5,
      "bbox_min": [
        1580.0,
        845.0,
        135.0
      ],
      "bbox_max": [
        1600.0,
        890.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        135.0
      ],
      "bbox_max": [
        1598.0,
        845.0,
        138.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        860.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1598.0,
        860.0,
        138.5
      ],
      "bbox_max": [
        1600.0,
        860.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        840.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1600.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        840.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1530.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1530.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -579.8275756835938,
      "bbox_min": [
        1530.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1530.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1600.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1530.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1630.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1554.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.9998779296875,
      "bbox_min": [
        1615.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1555.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1534.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1534.9998779296875,
      "bbox_min": [
        1535.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        260.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1480.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 1691.8072509765625,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        0.9265016913414001,
        -0.0
      ],
      "plane_d": -1711.133544921875,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        0.3892177939414978,
        0.0
      ],
      "plane_d": 900.0033569335938,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        134.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 558.7955932617188,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        139.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37629082798957825,
        0.9265016913414001,
        0.0
      ],
      "plane_d": -578.1218872070312,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        139.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        139.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        139.0
      ],
      "bbox_max": [
        1497.7283935546875,
        1225.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1480.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1480.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1530.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1480.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1480.0,
        1350.0,
        115.65217590332031
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1480.0,
        1380.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1690.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1480.0,
        1380.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1480.0,
        1380.0,
        138.0
      ],
      "bbox_max": [
        1530.0,
        1470.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1480.0,
        1380.0,
        138.0
      ],
      "bbox_max": [
        1499.7767333984375,
        1399.7767333984375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08662962168455124,
        0.0,
        0.9962406754493713
      ],
      "plane_d": 8.662956237792969,
      "bbox_min": [
        1250.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1250.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03874197229743004,
        -0.8944270610809326,
        0.4455326497554779
      ],
      "plane_d": 1443.9354248046875,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1250.0,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1257.887939453125,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1250.0,
        1580.0,
        101.43550872802734
      ],
      "bbox_max": [
        1480.0,
        1610.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1266.5,
        1580.0,
        138.0
      ],
      "bbox_max": [
        1270.0,
        1580.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1250.0,
        1580.0,
        101.43550872802734
      ],
      "bbox_max": [
        1270.0,
        1598.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      "bbox_max": [
        1270.0,
        1590.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1250.0,
        1580.0,
        126.57142639160156
      ],
      "bbox_max": [
        1270.0,
        1580.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1250.0,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        112.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1250.0,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1269.77294921875,
        1598.0,
        112.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1250.0,
        1590.0,
        101.43550872802734
      ],
      "bbox_max": [
        1266.508544921875,
        1598.0,
        110.11428833007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1270.0001220703125,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1370.0,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1370.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1150.0,
      "bbox_min": [
        1336.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1150.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1150.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 709.2808227539062,
      "bbox_min": [
        1346.0,
        1160.0,
        118.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 491.9349670410156,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1160.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1159.9998779296875,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1160.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1149.9998779296875,
      "bbox_min": [
        1300.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1340.0,
        1160.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1312.0,
      "bbox_min": [
        1312.0,
        1150.0,
        104.00001525878906
      ],
      "bbox_max": [
        1312.0,
        1160.0,
        106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1312.0,
      "bbox_min": [
        1312.0,
        1150.0,
        100.0
      ],
      "bbox_max": [
        1312.0,
        1160.0,
        104.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1290.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1480.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1120.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1475.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1395.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1120.0,
        130.0
      ],
      "bbox_max": [
        1475.0,
        1128.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -711.0697021484375,
      "bbox_min": [
        1290.0,
        1128.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1159.9998779296875,
      "bbox_min": [
        1290.0,
        1160.0,
        120.0
      ],
      "bbox_max": [
        1350.0,
        1170.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1290.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1310.0,
        1170.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1455.0,
      "bbox_min": [
        1455.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1475.0,
      "bbox_min": [
        1475.0,
        1128.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04339630529284477,
        -0.04339630529284477,
        0.9981150031089783
      ],
      "plane_d": 7.377372741699219,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 42.4263916015625,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1420.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.71063232421875,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1380.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        1280.0,
        1180.0001220703125,
        138.0
      ],
      "bbox_max": [
        1280.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1362.071044921875,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1290.0,
        1180.0001220703125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1160.0,
      "bbox_min": [
        1280.0,
        1160.0,
        138.0
      ],
      "bbox_max": [
        1290.0,
        1160.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1834.335693359375,
      "bbox_min": [
        1332.928955078125,
        1217.928955078125,
        138.0
      ],
      "bbox_max": [
        1362.071044921875,
        1247.071044921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1814.335693359375,
      "bbox_min": [
        1332.928955078125,
        1217.928955078125,
        138.0
      ],
      "bbox_max": [
        1347.928955078125,
        1232.928955078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1300.0,
        1205.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1250.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1250.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1270.0001220703125,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        1190.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1297.928955078125,
        1252.9288330078125,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1814.3355712890625,
      "bbox_min": [
        1297.928955078125,
        1252.9288330078125,
        138.0
      ],
      "bbox_max": [
        1312.928955078125,
        1267.9288330078125,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9996317028999329,
        0.027140598744153976,
        0.0
      ],
      "plane_d": 1440.6982421875,
      "bbox_min": [
        1479.7767333984375,
        1419.7767333984375,
        138.0
      ],
      "bbox_max": [
        1480.0,
        1428.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1480.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        60.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1476.8182373046875,
        670.0,
        60.000030517578125
      ],
      "bbox_max": [
        1480.0,
        680.0,
        61.66666793823242
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1380.0,
        670.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        80.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1340.0,
        907.6923217773438,
        80.0
      ],
      "bbox_max": [
        1480.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        1340.0,
        907.6923217773438,
        98.0
      ],
      "bbox_max": [
        1340.0,
        927.6923217773438,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        1480.0,
        910.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        100.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1470.0,
      "bbox_min": [
        1470.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1480.0,
        670.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        933.3333129882812,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        81.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        933.3333129882812,
        80.0
      ],
      "bbox_max": [
        1510.0,
        940.0,
        81.66666412353516
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        1480.0,
        670.0,
        61.66666793823242
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1480.0,
        670.0,
        61.66666793823242
      ],
      "bbox_max": [
        1500.0,
        960.0,
        100.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1480.0,
        670.0,
        61.66666793823242
      ],
      "bbox_max": [
        1500.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1480.0,
        670.0,
        61.66666793823242
      ],
      "bbox_max": [
        1500.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1480.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        1500.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1490.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1500.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1500.0,
        670.0,
        72.14286041259766
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1500.0,
        670.0,
        72.14286041259766
      ],
      "bbox_max": [
        1530.0,
        936.6666870117188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1510.0,
        670.0,
        77.38095092773438
      ],
      "bbox_max": [
        1530.0,
        900.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1510.0,
        670.0,
        77.38095092773438
      ],
      "bbox_max": [
        1530.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1510.0,
        670.0,
        77.38095092773438
      ],
      "bbox_max": [
        1515.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1510.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1520.0,
        900.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1500.0,
        670.0,
        72.14286041259766
      ],
      "bbox_max": [
        1510.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4640069603919983,
        0.0,
        0.8858315348625183
      ],
      "plane_d": 632.1040649414062,
      "bbox_min": [
        1500.0,
        670.0,
        72.14286041259766
      ],
      "bbox_max": [
        1510.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1500.0,
        700.0,
        78.0
      ],
      "bbox_max": [
        1510.0,
        700.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1500.0,
        880.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1500.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1500.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1250.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1250.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1258.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -1046.4798583984375,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1380.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1480.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -700.0357666015625,
      "bbox_min": [
        1380.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1380.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1454.9998779296875,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1394.9998779296875,
      "bbox_min": [
        1395.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1395.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1455.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1110.0,
        138.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1474.9998779296875,
      "bbox_min": [
        1475.0,
        1110.0,
        120.0
      ],
      "bbox_max": [
        1475.0,
        1120.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        260.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        140.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        600.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1301.3914794921875,
      "bbox_min": [
        260.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -429.3250732421875,
      "bbox_min": [
        445.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        450.0,
        1425.0,
        70.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        260.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        -0.0,
        0.8944272398948669
      ],
      "plane_d": -295.1610107421875,
      "bbox_min": [
        500.0,
        1440.0,
        60.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        600.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        600.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1425.0,
        78.0
      ],
      "bbox_max": [
        404.0,
        1425.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        260.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1500.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        450.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        450.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1424.9998779296875,
      "bbox_min": [
        400.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        460.0,
        1425.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        460.0,
        1420.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1425.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        720.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        720.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1472.83544921875,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        720.0,
        1420.0,
        64.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        730.0,
        1440.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        69.1110610961914
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1450.0,
        71.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        780.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        780.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        871.110595703125,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        871.110595703125,
        1450.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1215.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1690.0,
        128.57142639160156
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1420.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        128.57142639160156
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1670.0,
        128.57142639160156
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1650.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1235.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1238.8043212890625,
        1598.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.5,
        1590.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1235.0,
        1580.0,
        118.0
      ],
      "bbox_max": [
        1238.5,
        1580.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 508.5424499511719,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -510.2789306640625,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1590.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        1235.0,
        1580.0,
        120.0
      ],
      "bbox_max": [
        1250.0,
        1580.0,
        128.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46532946825027466,
        0.0,
        -0.885137677192688
      ],
      "plane_d": 679.1281127929688,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        1235.0,
        1590.0,
        110.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4653295874595642,
        0.0,
        0.8851376175880432
      ],
      "plane_d": -680.8985595703125,
      "bbox_min": [
        1238.8043212890625,
        1590.0,
        112.11428833007812
      ],
      "bbox_max": [
        1250.0,
        1598.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1690.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1036.5,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1690.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1183.0,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1200.0,
        1650.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1590.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1615.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1037.2222900390625,
        1620.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1187.731689453125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        138.69459533691406
      ],
      "bbox_max": [
        1187.731689453125,
        1690.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "bbox_max": [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1187.731689453125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        138.69459533691406
      ],
      "bbox_max": [
        1187.731689453125,
        1630.64794921875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1590.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1590.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1590.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1000.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1460.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1440.0,
        80.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1110.0,
        1446.2857666015625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1110.0,
        1446.2857666015625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1110.0,
        1453.4285888671875,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1457.857177734375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1120.0,
        1453.4285888671875,
        98.57142639160156
      ],
      "bbox_max": [
        1120.0,
        1457.2857666015625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1420.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1420.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1090.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1460.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1090.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1090.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1090.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.49658203125,
      "bbox_min": [
        1140.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.293701171875,
      "bbox_min": [
        1140.0,
        1420.0,
        118.0
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1338.8775634765625,
      "bbox_min": [
        1140.0,
        1434.8214111328125,
        119.28571319580078
      ],
      "bbox_max": [
        1142.5,
        1435.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1431.25,
        118.0
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1129.9998779296875,
      "bbox_min": [
        1120.0,
        1433.392822265625,
        118.0
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        -0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": 1338.8778076171875,
      "bbox_min": [
        1120.0,
        1433.392822265625,
        118.0
      ],
      "bbox_max": [
        1130.0,
        1434.607177734375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1363.0731201171875,
      "bbox_min": [
        1130.0,
        1459.107177734375,
        118.0
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1135.5,
        1459.7427978515625,
        118.0
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        119.28571319580078
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1431.25,
        118.0
      ],
      "bbox_max": [
        1120.0,
        1458.892822265625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        -0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": 1338.877685546875,
      "bbox_min": [
        1090.0,
        1431.25,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1433.1785888671875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912998855113983,
        -0.9678216576576233,
        -0.2419552356004715
      ],
      "plane_d": 1363.0733642578125,
      "bbox_min": [
        1110.0,
        1457.6785888671875,
        118.0
      ],
      "bbox_max": [
        1120.0,
        1458.892822265625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1090.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": -324.3080139160156,
      "bbox_min": [
        1090.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1153.0,
        1460.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.29367065429688,
      "bbox_min": [
        1090.0,
        1420.0,
        100.0
      ],
      "bbox_max": [
        1153.0,
        1432.0,
        118.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1431.75,
        100.0
      ],
      "bbox_max": [
        1130.0,
        1460.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        -0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": 1322.496826171875,
      "bbox_min": [
        1120.0,
        1432.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        -0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": 1338.8778076171875,
      "bbox_min": [
        1120.0,
        1433.892822265625,
        113.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1435.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1431.75,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06913010776042938,
        -0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": 1338.877685546875,
      "bbox_min": [
        1090.0,
        1431.75,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.4967041015625,
      "bbox_min": [
        1090.0,
        1432.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1435.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1110.0,
        1457.2857666015625,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912998855113983,
        -0.9678216576576233,
        -0.2419552356004715
      ],
      "plane_d": 1363.0733642578125,
      "bbox_min": [
        1110.0,
        1458.1785888671875,
        110.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1130.0,
        1432.0,
        101.42857360839844
      ],
      "bbox_max": [
        1153.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.49658203125,
      "bbox_min": [
        1140.0,
        1432.0,
        114.28571319580078
      ],
      "bbox_max": [
        1153.0,
        1434.228515625,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        -0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": 1469.8260498046875,
      "bbox_min": [
        1130.0,
        1457.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1363.0731201171875,
      "bbox_min": [
        1130.0,
        1459.607177734375,
        116.42857360839844
      ],
      "bbox_max": [
        1135.5,
        1460.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1139.9998779296875,
      "bbox_min": [
        1090.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1140.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1338.8775634765625,
      "bbox_min": [
        1140.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        -0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": 1322.49658203125,
      "bbox_min": [
        1140.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1435.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1140.0,
        1420.0,
        139.2857208251953
      ],
      "bbox_max": [
        1142.5,
        1430.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1129.9998779296875,
      "bbox_min": [
        1090.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        1459.8214111328125,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1090.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1130.0,
        1458.392822265625,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        -0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": 1338.8778076171875,
      "bbox_min": [
        1120.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1130.0,
        1434.107177734375,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.274720162153244,
        0.0,
        -0.961524248123169
      ],
      "plane_d": -179.25439453125,
      "bbox_min": [
        1120.0,
        1420.0,
        133.57144165039062
      ],
      "bbox_max": [
        1130.0,
        1430.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        1458.392822265625,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1090.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1110.0,
        1432.6785888671875,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        -0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": 1338.877685546875,
      "bbox_min": [
        1090.0,
        1430.0,
        120.0
      ],
      "bbox_max": [
        1110.0,
        1432.6785888671875,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1110.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        1458.392822265625,
        133.57144165039062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06912998855113983,
        -0.9678216576576233,
        -0.2419552356004715
      ],
      "plane_d": 1363.0733642578125,
      "bbox_min": [
        1110.0,
        1455.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        1458.392822265625,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.25601196289062,
      "bbox_min": [
        1130.0,
        1420.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        1459.8214111328125,
        139.2857208251953
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1363.0731201171875,
      "bbox_min": [
        1130.0,
        1455.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        1459.8214111328125,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1215.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1170.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1420.0,
        118.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1215.0,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1215.0,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1215.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 138.0,
      "bbox_min": [
        1235.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1235.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -21.2132568359375,
      "bbox_min": [
        1240.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1240.0,
        1220.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1220.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1240.0,
        1360.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1240.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1235.0,
        1390.0,
        138.0
      ],
      "bbox_max": [
        1240.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1235.0,
        1400.0,
        138.0
      ],
      "bbox_max": [
        1240.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1215.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1300.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1390.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1300.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        1030.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1280.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1170.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1280.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1200.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1200.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        1200.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1250.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1200.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1300.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1200.0,
        1280.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1300.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        95.71428680419922
      ],
      "bbox_max": [
        1215.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1030.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1403.7142333984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1403.7142333984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": -1320.451904296875,
      "bbox_min": [
        1110.0,
        1392.142822265625,
        95.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1393.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49613896012306213,
        0.0,
        0.8682432174682617
      ],
      "plane_d": 481.2547912597656,
      "bbox_min": [
        1090.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1215.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1160.0,
        1390.0,
        100.0199966430664
      ],
      "bbox_max": [
        1215.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        1180.0,
        1400.0,
        120.0
      ],
      "bbox_max": [
        1215.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1160.0,
        1390.0,
        100.0199966430664
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        108.57141876220703
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1129.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1180.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1109.9998779296875,
      "bbox_min": [
        1090.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        136.42857360839844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06913018971681595,
        0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": -1419.4140625,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1420.0,
        130.71429443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1090.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1420.0,
        110.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.29367065429688,
      "bbox_min": [
        1090.0,
        1418.0,
        100.0
      ],
      "bbox_max": [
        1110.0,
        1420.0,
        105.71428680419922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06912980228662491,
        0.9678215980529785,
        -0.2419552356004715
      ],
      "plane_d": -1419.4136962890625,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        136.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14543606340885162,
        0.848375678062439,
        0.5090254545211792
      ],
      "plane_d": -1095.3739013671875,
      "bbox_min": [
        1120.0,
        1415.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        116.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27472153306007385,
        0.0,
        0.9615238904953003
      ],
      "plane_d": 203.29409790039062,
      "bbox_min": [
        1120.0,
        1418.0,
        108.57142639160156
      ],
      "bbox_max": [
        1130.0,
        1420.0,
        111.42857360839844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.2559814453125,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1420.0,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913018971681595,
        0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": -1395.218505859375,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1420.0,
        133.57144165039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25640997290611267,
        -0.3589743673801422,
        0.8974359035491943
      ],
      "plane_d": 698.7689208984375,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1420.0,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747208774089813,
        0.0,
        0.9615241289138794
      ],
      "plane_d": 203.29335021972656,
      "bbox_min": [
        1110.0,
        1418.0,
        105.71428680419922
      ],
      "bbox_max": [
        1120.0,
        1420.0,
        108.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": -1320.451904296875,
      "bbox_min": [
        1110.0,
        1390.0,
        100.0
      ],
      "bbox_max": [
        1120.0,
        1392.7142333984375,
        113.57142639160156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1130.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1180.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1130.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1176.5,
        1420.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211754322052,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 203.293701171875,
      "bbox_min": [
        1130.0,
        1418.0,
        111.42857360839844
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1130.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1160.0,
        1418.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1140.0,
        1415.0,
        114.28571319580078
      ],
      "bbox_max": [
        1160.0,
        1418.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1140.0,
        1415.0,
        119.28571319580078
      ],
      "bbox_max": [
        1142.5,
        1415.1785888671875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05594536289572716,
        0.9790449142456055,
        0.19580897688865662
      ],
      "plane_d": -1320.451904296875,
      "bbox_min": [
        1130.0,
        1390.0,
        101.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1393.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913021951913834,
        0.9678215980529785,
        -0.24195539951324463
      ],
      "plane_d": -1395.2186279296875,
      "bbox_min": [
        1130.0,
        1390.0,
        116.42857360839844
      ],
      "bbox_max": [
        1140.0,
        1390.892822265625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1160.0,
        1390.0,
        118.0
      ],
      "bbox_max": [
        1176.5,
        1420.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1139.9998779296875,
      "bbox_min": [
        1130.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1159.9998779296875,
      "bbox_min": [
        1140.0,
        1390.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1140.0,
        1415.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1454358845949173,
        0.8483757376670837,
        0.5090254545211792
      ],
      "plane_d": -1095.374267578125,
      "bbox_min": [
        1142.5,
        1415.0,
        120.0
      ],
      "bbox_max": [
        1160.0,
        1418.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27472153306007385,
        0.0,
        -0.9615238904953003
      ],
      "plane_d": -179.25601196289062,
      "bbox_min": [
        1130.0,
        1390.1785888671875,
        120.0
      ],
      "bbox_max": [
        1140.0,
        1420.0,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913021951913834,
        0.9678215980529785,
        -0.24195539951324463
      ],
      "plane_d": -1395.2186279296875,
      "bbox_min": [
        1130.0,
        1390.1785888671875,
        120.0
      ],
      "bbox_max": [
        1140.0,
        1395.0,
        139.2857208251953
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        1030.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1200.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        1030.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        1170.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1120.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1120.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        825.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        825.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1186.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1215.0,
        1030.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1030.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1186.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1120.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1095.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1200.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1095.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": 700.03173828125,
      "bbox_min": [
        1200.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1085.0,
      "bbox_min": [
        1210.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1082.0,
        118.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1030.0,
        970.0,
        120.0
      ],
      "bbox_max": [
        1190.4000244140625,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1189.199951171875,
        970.0,
        130.0
      ],
      "bbox_max": [
        1190.0,
        970.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1050.0,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1189.199951171875,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1109.199951171875,
        130.0
      ],
      "bbox_max": [
        1050.4000244140625,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1030.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1050.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1030.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.0,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1163.7333984375,
        1113.3333740234375,
        130.0
      ],
      "bbox_max": [
        1170.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1189.599853515625,
        930.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1189.599853515625,
        960.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1189.5999755859375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        970.0000610351562,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1189.599853515625,
        1080.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1189.599853515625,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1193.3333740234375,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1193.3333740234375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1193.3333740234375,
        1119.199951171875,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1193.3333740234375,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1193.3333740234375,
        1030.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1199.199951171875,
        1030.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": -701.69580078125,
      "bbox_min": [
        1200.0,
        1035.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1200.0,
        1035.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1085.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        1200.0,
        1035.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1058.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1055.0,
      "bbox_min": [
        1210.0,
        1055.0,
        138.0
      ],
      "bbox_max": [
        1235.0,
        1058.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1055.0,
        138.0
      ],
      "bbox_max": [
        1210.0,
        1058.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": 700.03173828125,
      "bbox_min": [
        1200.0,
        1055.0,
        120.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1210.0,
      "bbox_min": [
        1210.0,
        1055.0,
        120.0
      ],
      "bbox_max": [
        1210.0,
        1085.0,
        138.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1186.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1186.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1235.0,
        1120.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1200.0,
        1030.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1200.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1235.0,
        1030.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1235.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1235.0,
        1030.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1030.0,
        90.52631378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1235.0,
        1030.0,
        90.52631378173828
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 137.99998474121094,
      "bbox_min": [
        1235.0,
        1035.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1055.0,
      "bbox_min": [
        1235.0,
        1035.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1055.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1035.0,
      "bbox_min": [
        1235.0,
        1035.0,
        138.0
      ],
      "bbox_max": [
        1250.0,
        1035.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        780.0,
        930.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        780.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        71.0
      ],
      "bbox_max": [
        945.5584716796875,
        1377.16455078125,
        76.55585479736328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        820.0,
        1120.0,
        64.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        960.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        69.11104583740234
      ],
      "bbox_max": [
        890.0,
        1400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        71.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        780.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1400.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1143.07421875,
        133.9837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        871.1104736328125,
        1377.16455078125,
        100.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        871.1104736328125,
        1400.0,
        100.0
      ],
      "bbox_max": [
        890.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        980.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        980.0,
        1140.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1420.0,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        980.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1420.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        980.0,
        1160.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1160.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1000.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1020.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1000.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10459312796592712,
        0.04183724895119667,
        0.9936347007751465
      ],
      "plane_d": -20.709434509277344,
      "bbox_min": [
        1020.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1410.0,
      "bbox_min": [
        1020.0,
        1410.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1410.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        988.9999389648438,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1140.0,
      "bbox_min": [
        988.9999389648438,
        1140.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        930.0,
        78.88890075683594
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        950.0,
        930.0,
        78.88890075683594
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043035984039307,
        0.0,
        0.9938838481903076
      ],
      "plane_d": 26.50244140625,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        78.88890075683594
      ],
      "bbox_max": [
        950.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -950.0,
      "bbox_min": [
        950.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        1100.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1100.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        865.0,
        935.0,
        110.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        865.0,
        980.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        865.0,
        980.0,
        110.0
      ],
      "bbox_max": [
        1000.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        118.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        110.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        120.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": -1126.7999267578125,
      "bbox_min": [
        1010.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1020.0,
        1109.5999755859375,
        130.0
      ],
      "bbox_max": [
        1030.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        480.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1110.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        1040.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1110.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        480.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        700.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        1110.0,
        110.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        480.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1400.0,
      "bbox_min": [
        480.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        480.0,
        1170.0,
        78.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        480.0,
        1290.0,
        80.0
      ],
      "bbox_max": [
        500.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        500.0,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        579.4630737304688,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1394.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1384.3714599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        647.2877197265625,
        1346.4150390625,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1384.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1282.9407958984375,
      "bbox_min": [
        579.4630737304688,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        664.30078125,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257307887077332,
        0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": -1386.7620849609375,
      "bbox_min": [
        647.2877197265625,
        1384.3714599609375,
        80.0
      ],
      "bbox_max": [
        664.30078125,
        1394.3714599609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        480.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1400.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        1150.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1301.3914794921875,
      "bbox_min": [
        270.0,
        1090.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1420.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        400.0,
        1090.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1420.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        403.9993896484375,
        1415.9998779296875,
        79.99970245361328
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        400.0,
        1405.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -429.3250427246094,
      "bbox_min": [
        440.0,
        1090.0,
        60.0
      ],
      "bbox_max": [
        480.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        440.0,
        1090.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1412.4998779296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1412.4998779296875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        460.0,
        1412.4998779296875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        440.0,
        1405.0,
        85.0
      ],
      "bbox_max": [
        460.0,
        1412.4998779296875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        460.0,
        1110.0,
        80.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        1090.0,
        100.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1110.0,
        100.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        480.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1415.0,
      "bbox_min": [
        270.0,
        1385.0,
        78.0
      ],
      "bbox_max": [
        460.0,
        1420.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        400.0,
        1385.0,
        80.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        400.0,
        1404.9998779296875,
        80.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5449883937835693,
        0.0,
        -0.8384436964988708
      ],
      "plane_d": -168.5271759033203,
      "bbox_min": [
        440.0,
        1404.9998779296875,
        80.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1404.9998779296875,
        85.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        460.0,
        1404.9998779296875,
        98.0
      ],
      "bbox_max": [
        460.0,
        1415.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1412.5,
        80.0
      ],
      "bbox_max": [
        440.0,
        1415.0,
        85.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -109.1201171875,
      "bbox_min": [
        400.0,
        1415.0,
        78.0
      ],
      "bbox_max": [
        460.0,
        1420.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        440.0,
        1415.0,
        100.0
      ],
      "bbox_max": [
        444.0,
        1417.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        444.0,
        1415.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1420.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        460.0,
        1415.0,
        98.0
      ],
      "bbox_max": [
        460.0,
        1420.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        260.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        519.3518676757812,
        1550.0,
        150.0
      ],
      "bbox_max": [
        584.3502807617188,
        1634.350341796875,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1723.4124755859375,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1654.800048828125,
        1060.0
      ],
      "bbox_max": [
        1723.4124755859375,
        1690.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        429.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1037.5947265625,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        429.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        1148.2298583984375,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        1170.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        379.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.300048828125,
        1630.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1690.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1225.0,
        1630.0,
        270.0
      ],
      "bbox_max": [
        1225.0,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        1170.0,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1187.731689453125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -158.0,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 148.0,
      "bbox_min": [
        1187.731689453125,
        1630.0,
        148.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        158.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.9238780736923218,
        -0.3826870620250702,
        0.0
      ],
      "plane_d": -473.3931884765625,
      "bbox_min": [
        1200.0,
        1660.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        -0.9238780736923218,
        0.0
      ],
      "plane_d": 1085.2369384765625,
      "bbox_min": [
        1205.85791015625,
        1660.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870620250702,
        -0.9238780736923218,
        -0.0
      ],
      "plane_d": 2018.9932861328125,
      "bbox_min": [
        1220.0,
        1660.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1680.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238780736923218,
        -0.3826870620250702,
        -0.0
      ],
      "plane_d": 1780.869384765625,
      "bbox_min": [
        1234.14208984375,
        1660.0,
        148.0
      ],
      "bbox_max": [
        1240.0,
        1674.14208984375,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038732245564460754,
        -0.8944514393806458,
        0.44548454880714417
      ],
      "plane_d": 1443.968505859375,
      "bbox_min": [
        1100.0,
        1610.0,
        140.0
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9302632212638855,
        0.0,
        0.36689305305480957
      ],
      "plane_d": 1118.8017578125,
      "bbox_min": [
        1257.887939453125,
        1629.6195068359375,
        140.0
      ],
      "bbox_max": [
        1258.199951171875,
        1630.0,
        140.79110717773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 230.0,
      "bbox_min": [
        1100.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5881717205047607,
        0.0,
        -0.8087361454963684
      ],
      "plane_d": -502.1515808105469,
      "bbox_min": [
        1170.0,
        1610.0,
        230.0
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1225.0,
      "bbox_min": [
        1225.0,
        1610.0,
        270.0
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.030754676088690758,
        0.0,
        -0.9995269775390625
      ],
      "plane_d": 117.94418334960938,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030754676088690758,
        0.0,
        0.9995269775390625
      ],
      "plane_d": -119.9432373046875,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 156.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1235.0,
        1630.0,
        157.38461303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        156.0
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        157.38461303710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -158.0,
      "bbox_min": [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1610.0,
        157.38461303710938
      ],
      "bbox_max": [
        1215.0,
        1630.0,
        158.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 176.99998474121094,
      "bbox_min": [
        1468.300048828125,
        1610.0,
        177.0
      ],
      "bbox_max": [
        1488.300048828125,
        1630.0,
        177.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1564.9998779296875,
      "bbox_min": [
        1290.0,
        1565.0,
        190.0
      ],
      "bbox_max": [
        1345.0,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8000000715255737,
        0.0,
        0.6000000238418579
      ],
      "plane_d": 918.0001220703125,
      "bbox_min": [
        1290.0,
        1565.0,
        190.0
      ],
      "bbox_max": [
        1297.5,
        1570.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1570.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1325.0,
      "bbox_min": [
        1299.4774169921875,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        149.07408142089844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.6139406561851501,
        -0.7893522381782532
      ],
      "plane_d": 1066.4149169921875,
      "bbox_min": [
        1325.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1560.5,
        149.07408142089844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1340.0,
      "bbox_min": [
        1325.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1560.5,
        149.07408142089844
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.5,
      "bbox_min": [
        1325.0,
        1557.0,
        143.5
      ],
      "bbox_max": [
        1326.0,
        1560.5,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.0,
      "bbox_min": [
        1299.4774169921875,
        1550.0,
        143.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1555.9044189453125,
        143.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        980.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1550.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1660.0,
      "bbox_min": [
        260.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1550.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1660.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1490.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1680.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1490.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1469.9998779296875,
        280.0
      ],
      "bbox_max": [
        1735.0,
        1490.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1220.0,
      "bbox_min": [
        1660.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        410.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1660.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        1680.0,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1469.9998779296875,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49613896012306213,
        0.0,
        -0.8682432174682617
      ],
      "plane_d": -713.6958618164062,
      "bbox_min": [
        1683.5,
        1400.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 941.8319091796875,
      "bbox_min": [
        1748.13330078125,
        1410.0,
        178.0
      ],
      "bbox_max": [
        1750.0,
        1420.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1409.9998779296875,
      "bbox_min": [
        1748.13330078125,
        1410.0,
        178.0
      ],
      "bbox_max": [
        1750.0,
        1410.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 177.99998474121094,
      "bbox_min": [
        1750.0,
        1400.0,
        178.0
      ],
      "bbox_max": [
        1770.0,
        1420.0,
        178.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        1680.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1750.0,
        1469.9998779296875,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        -0.0,
        -0.8944272398948669
      ],
      "plane_d": 941.8319091796875,
      "bbox_min": [
        1710.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1750.0,
        1420.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1409.9998779296875,
      "bbox_min": [
        1710.0,
        1400.0,
        178.933349609375
      ],
      "bbox_max": [
        1750.0,
        1410.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 198.0,
      "bbox_min": [
        1710.0,
        1400.0,
        198.0
      ],
      "bbox_max": [
        1740.0,
        1410.0,
        198.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 183.8477783203125,
      "bbox_min": [
        1660.0,
        1400.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1420.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5773502588272095,
        0.5773502588272095,
        -0.5773502588272095
      ],
      "plane_d": 311.7691650390625,
      "bbox_min": [
        1660.0,
        1400.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1420.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        1660.0,
        1400.0,
        400.0
      ],
      "bbox_max": [
        1680.0,
        1420.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1680.0,
      "bbox_min": [
        1660.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        400.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": 1371.7872314453125,
      "bbox_min": [
        1660.0,
        1220.0,
        260.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        1660.0,
        1220.0,
        400.0
      ],
      "bbox_max": [
        1680.0,
        1400.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -400.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1400.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1750.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1750.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1755.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.800000011920929,
        -0.0,
        -0.5999999642372131
      ],
      "plane_d": 1452.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1400.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -200.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1360.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.800000011920929,
        -0.5999999642372131
      ],
      "plane_d": 1084.0,
      "bbox_min": [
        1680.0,
        1220.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1750.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.0,
        0.7071068286895752
      ],
      "plane_d": -1350.5740966796875,
      "bbox_min": [
        1680.0,
        1220.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1360.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1360.0,
        230.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -749.533203125,
      "bbox_min": [
        1680.0,
        1280.0,
        220.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1330.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1096.015625,
      "bbox_min": [
        1680.0,
        1320.0,
        220.0
      ],
      "bbox_max": [
        1690.0001220703125,
        1330.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 791.9596557617188,
      "bbox_min": [
        1680.0,
        1320.0,
        200.0
      ],
      "bbox_max": [
        1710.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1680.0,
        1360.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 240.0,
      "bbox_min": [
        1680.0,
        1250.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        1250.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 1096.015625,
      "bbox_min": [
        1680.0,
        1280.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1330.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1680.0,
        1320.0,
        230.0
      ],
      "bbox_max": [
        1700.0,
        1320.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -749.533203125,
      "bbox_min": [
        1680.0,
        1280.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        1290.0,
        230.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1360.0,
      "bbox_min": [
        1690.0001220703125,
        1360.0,
        210.0
      ],
      "bbox_max": [
        1700.0,
        1360.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1695.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1385.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        1695.0,
        1235.0,
        140.0
      ],
      "bbox_max": [
        1710.0,
        1235.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1660.0,
        670.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": 1009.5543212890625,
      "bbox_min": [
        1660.0,
        670.0,
        258.0
      ],
      "bbox_max": [
        1680.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1660.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1660.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1660.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1680.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": 1578.9068603515625,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        0.24253562092781067
      ],
      "plane_d": -894.9564819335938,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -1661.3690185546875,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        -0.0,
        -0.24253562092781067
      ],
      "plane_d": 1651.6676025390625,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9701424837112427,
        -0.24253562092781067
      ],
      "plane_d": -822.1957397460938,
      "bbox_min": [
        1665.0,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701424837112427,
        0.0,
        -0.24253562092781067
      ],
      "plane_d": -1588.6082763671875,
      "bbox_min": [
        1672.5,
        875.0,
        140.0
      ],
      "bbox_max": [
        1675.0,
        885.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1680.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        1700.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1700.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1770.0,
        1220.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 356.4822998046875,
      "bbox_min": [
        1700.0,
        895.0001220703125,
        220.0
      ],
      "bbox_max": [
        1770.0,
        1210.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1766.0001220703125,
        895.0001220703125,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1766.0001220703125,
        895.0001220703125,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1700.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1714.14208984375,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -1187.0584716796875,
      "bbox_min": [
        1700.0,
        1210.0,
        310.0
      ],
      "bbox_max": [
        1750.0,
        1220.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1700.0,
        1210.0,
        310.0
      ],
      "bbox_max": [
        1714.14208984375,
        1220.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1700.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1700.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1770.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1700.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1700.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1770.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1700.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1766.0001220703125,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1680.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 1234.2078857421875,
      "bbox_min": [
        1690.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1941.239990234375,
      "bbox_min": [
        1690.0,
        700.0,
        139.99998474121094
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 346.48236083984375,
      "bbox_min": [
        1690.0,
        1195.85791015625,
        140.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5883489847183228,
        0.5883489847183228,
        0.5546989440917969
      ],
      "plane_d": 116.3343505859375,
      "bbox_min": [
        1690.0,
        1195.85791015625,
        310.0
      ],
      "bbox_max": [
        1700.0,
        1210.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1690.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        325.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1690.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1700.0,
        700.0,
        325.00006103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1690.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1690.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1690.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1700.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1690.0,
        700.0,
        309.99993896484375
      ],
      "bbox_max": [
        1700.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1680.0,
        700.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1680.0,
        700.0,
        258.0
      ],
      "bbox_max": [
        1690.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -840.0,
      "bbox_min": [
        1680.0,
        840.0,
        140.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1680.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1680.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1690.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        260.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        260.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1350.0,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1550.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1588.2841796875,
        1508.2841796875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1350.0,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1445.0,
        1550.0,
        210.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        1400.0,
        1540.0,
        195.0
      ],
      "bbox_max": [
        1445.0,
        1550.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1400.0,
        1545.0,
        195.0
      ],
      "bbox_max": [
        1420.0,
        1550.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        1350.0,
        1469.9998779296875,
        140.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 188.0,
      "bbox_min": [
        1350.0,
        1478.75,
        140.0
      ],
      "bbox_max": [
        1400.0,
        1550.0,
        200.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1350.0,
        1507.0,
        188.0
      ],
      "bbox_max": [
        1400.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        1350.0,
        1527.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1350.0,
        1527.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1371.0,
      "bbox_min": [
        1371.0,
        1527.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1528.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1520.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1527.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 200.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1527.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        1350.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1527.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1371.0,
      "bbox_min": [
        1371.0,
        1520.0,
        190.0
      ],
      "bbox_max": [
        1371.0,
        1527.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 153.5,
      "bbox_min": [
        1350.0,
        1478.75,
        140.0
      ],
      "bbox_max": [
        1373.25,
        1520.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": 1889.5894775390625,
      "bbox_min": [
        1365.75,
        1478.75,
        160.0
      ],
      "bbox_max": [
        1373.25,
        1493.75,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1520.0,
      "bbox_min": [
        1350.0,
        1520.0,
        140.0
      ],
      "bbox_max": [
        1370.0,
        1520.0,
        153.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1400.0,
      "bbox_min": [
        1350.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1469.9998779296875,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        9.39002404720668e-07,
        0.0
      ],
      "plane_d": -1630.0013427734375,
      "bbox_min": [
        1400.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1450.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 91.9239501953125,
      "bbox_min": [
        1400.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1450.0,
        714.2493896484375
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.213134765625,
      "bbox_min": [
        1400.0,
        1292.393798828125,
        140.0
      ],
      "bbox_max": [
        1507.24658203125,
        1450.0,
        714.2493896484375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1969.644775390625,
      "bbox_min": [
        1400.0,
        1292.393798828125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2019.644775390625,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 290.0,
      "bbox_min": [
        1443.1044921875,
        1363.1044921875,
        290.0
      ],
      "bbox_max": [
        1507.24658203125,
        1427.24658203125,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1989.644775390625,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        340.0
      ],
      "bbox_max": [
        1471.8912353515625,
        1391.8912353515625,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 340.0,
      "bbox_min": [
        1407.7491455078125,
        1327.7491455078125,
        340.0
      ],
      "bbox_max": [
        1471.8912353515625,
        1391.8912353515625,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1939.644775390625,
      "bbox_min": [
        1400.0,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1436.535888671875,
        1343.07177734375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        1400.0,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1436.535888671875,
        1343.07177734375,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1919.644775390625,
      "bbox_min": [
        1400.0,
        1292.393798828125,
        390.0
      ],
      "bbox_max": [
        1422.393798828125,
        1314.78759765625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.213134765625,
      "bbox_min": [
        1350.0,
        1314.78759765625,
        140.0
      ],
      "bbox_max": [
        1400.0,
        1469.9998779296875,
        601.1122436523438
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 210.0,
      "bbox_min": [
        1365.0,
        1460.0,
        210.0
      ],
      "bbox_max": [
        1400.0,
        1469.9998779296875,
        210.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1919.644775390625,
      "bbox_min": [
        1372.393798828125,
        1314.78759765625,
        390.0
      ],
      "bbox_max": [
        1400.0,
        1356.535888671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 390.0,
      "bbox_min": [
        1372.393798828125,
        1314.78759765625,
        390.0
      ],
      "bbox_max": [
        1400.0,
        1356.535888671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1939.644775390625,
      "bbox_min": [
        1386.535888671875,
        1343.07177734375,
        390.0
      ],
      "bbox_max": [
        1400.0,
        1356.535888671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1460.0,
      "bbox_min": [
        260.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        780.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1280.0,
      "bbox_min": [
        270.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        714.611572265625,
        1270.0,
        520.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        1000.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1000.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1280.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1270.0,
        140.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1270.0,
        260.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1270.0,
        260.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1270.0,
        260.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1290.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1460.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071045637130737,
        0.0,
        -0.7071089744567871
      ],
      "plane_d": 1051.69189453125,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071045637130737,
        0.0,
        -0.7071089744567871
      ],
      "plane_d": -815.064208984375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588188052177429,
        0.0,
        -0.965925931930542
      ],
      "plane_d": -187.09268188476562,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188052177429,
        0.0,
        -0.965925931930542
      ],
      "plane_d": 496.18896484375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.965927004814148,
        0.0,
        -0.25881466269493103
      ],
      "plane_d": 1330.576171875,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1340.0,
        1460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.0,
        -0.25881466269493103
      ],
      "plane_d": -1219.4710693359375,
      "bbox_min": [
        1300.0,
        1450.0,
        140.0
      ],
      "bbox_max": [
        1302.679443359375,
        1460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1390.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1460.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        1300.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1300.0,
        355.9431457519531
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        1030.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1030.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1200.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        1030.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        1175.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1200.0,
        1380.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        1030.0,
        1380.0,
        515.0
      ],
      "bbox_max": [
        1200.0,
        1390.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -515.0,
      "bbox_min": [
        1030.0,
        1300.0,
        515.0
      ],
      "bbox_max": [
        1200.0,
        1310.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1142.5,
        1390.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1460.0,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2747208774089813,
        0.0,
        -0.9615241289138794
      ],
      "plane_d": -179.2552032470703,
      "bbox_min": [
        1142.5,
        1418.75,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1431.25,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913001090288162,
        -0.9678215980529785,
        -0.24195531010627747
      ],
      "plane_d": 1338.8775634765625,
      "bbox_min": [
        1142.5,
        1418.75,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1431.25,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06913010776042938,
        0.9678216576576233,
        -0.24195532500743866
      ],
      "plane_d": -1419.4141845703125,
      "bbox_min": [
        1142.5,
        1418.75,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1420.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        647.2877197265625,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        647.2877197265625,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1384.3714599609375,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        717.8607788085938,
        1280.0,
        520.0
      ],
      "bbox_max": [
        719.4853515625,
        1285.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        0.30901700258255005,
        -0.0
      ],
      "plane_d": -1081.358154296875,
      "bbox_min": [
        270.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        0.8090178370475769,
        -0.0
      ],
      "plane_d": -1500.44677734375,
      "bbox_min": [
        270.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        699.5303955078125,
        1415.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -1414.9998779296875,
      "bbox_min": [
        270.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        647.2877197265625,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -183.8477783203125,
      "bbox_min": [
        400.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        647.2877197265625,
        1415.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1384.3714599609375,
      "bbox_min": [
        582.7122802734375,
        1384.3714599609375,
        140.0
      ],
      "bbox_max": [
        647.2877197265625,
        1384.3714599609375,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        839.914794921875,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        0.6373907923698425,
        -0.0
      ],
      "plane_d": -1563.5732421875,
      "bbox_min": [
        890.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        945.5584716796875,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1377.16455078125,
        140.0
      ],
      "bbox_max": [
        890.0,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        980.0,
        1280.0,
        180.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7921085953712463,
        -0.6103802919387817,
        0.0
      ],
      "plane_d": 534.706298828125,
      "bbox_min": [
        450.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        519.3518676757812,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1527.0,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        1266.0,
        1527.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1268.5347900390625,
        1547.0,
        160.0
      ],
      "bbox_max": [
        1290.9000244140625,
        1550.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 188.0,
      "bbox_min": [
        1268.5347900390625,
        1527.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1545.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1268.5347900390625,
        1527.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1545.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1320.0,
      "bbox_min": [
        1320.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1545.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6139406561851501,
        -0.7893522381782532
      ],
      "plane_d": 1066.4149169921875,
      "bbox_min": [
        1325.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1536.279052734375,
        165.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1325.0,
      "bbox_min": [
        1325.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1340.0,
        1536.279052734375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1340.0,
      "bbox_min": [
        1340.0,
        1530.0,
        160.0
      ],
      "bbox_max": [
        1340.0,
        1536.279052734375,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1507.0,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1510.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1268.5347900390625,
        1507.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1510.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1510.0,
      "bbox_min": [
        1290.0,
        1507.0,
        160.0
      ],
      "bbox_max": [
        1350.0,
        1510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1769.6600341796875,
      "bbox_min": [
        1290.0,
        1507.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -641.6615600585938,
      "bbox_min": [
        1318.75732421875,
        1507.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        1510.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1487.0,
      "bbox_min": [
        1266.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1318.75732421875,
        1507.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1268.5347900390625,
        1487.0,
        160.0
      ],
      "bbox_max": [
        1318.75732421875,
        1507.0,
        188.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826870322227478,
        -0.923878014087677,
        -0.0
      ],
      "plane_d": 1880.604248046875,
      "bbox_min": [
        1291.24267578125,
        1487.0,
        160.0
      ],
      "bbox_max": [
        1318.75732421875,
        1507.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.923878014087677,
        -0.3826870322227478,
        -0.0
      ],
      "plane_d": 1769.6600341796875,
      "bbox_min": [
        1291.24267578125,
        1499.3934326171875,
        160.0
      ],
      "bbox_max": [
        1318.75732421875,
        1507.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -641.6615600585938,
      "bbox_min": [
        1315.6065673828125,
        1499.3934326171875,
        160.0
      ],
      "bbox_max": [
        1318.75732421875,
        1507.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1305.0,
        1487.0,
        160.0
      ],
      "bbox_max": [
        1307.3125,
        1495.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9286678433418274,
        -0.37091267108917236,
        -0.0
      ],
      "plane_d": 1756.9979248046875,
      "bbox_min": [
        1304.4334716796875,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1308.826904296875,
        1487.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9606683254241943,
        -0.27769845724105835,
        -0.0
      ],
      "plane_d": 1668.831298828125,
      "bbox_min": [
        1307.3125,
        1481.76123046875,
        160.0
      ],
      "bbox_max": [
        1308.826904296875,
        1487.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        0.6246950626373291
      ],
      "plane_d": 888.6287841796875,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1526.9998779296875,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.6139406561851501,
        -0.7893522381782532
      ],
      "plane_d": 1066.4149169921875,
      "bbox_min": [
        1250.0,
        1527.0,
        140.0
      ],
      "bbox_max": [
        1350.0,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1325.0,
      "bbox_min": [
        1256.2222900390625,
        1531.2857666015625,
        145.44444274902344
      ],
      "bbox_max": [
        1340.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1340.0,
      "bbox_min": [
        1340.0,
        1531.2857666015625,
        145.44444274902344
      ],
      "bbox_max": [
        1340.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        -0.587769091129303,
        0.0
      ],
      "plane_d": -146.3585205078125,
      "bbox_min": [
        1256.2222900390625,
        1547.0,
        145.44444274902344
      ],
      "bbox_max": [
        1307.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        -0.951056718826294,
        0.0
      ],
      "plane_d": 1875.2275390625,
      "bbox_min": [
        1256.2222900390625,
        1547.0,
        145.44444274902344
      ],
      "bbox_max": [
        1305.2725830078125,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1546.9998779296875,
      "bbox_min": [
        1256.2222900390625,
        1547.0,
        145.44444274902344
      ],
      "bbox_max": [
        1268.5347900390625,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1263.017333984375,
        1547.0,
        145.44444274902344
      ],
      "bbox_max": [
        1268.5347900390625,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1263.017333984375,
        1547.0,
        145.44444274902344
      ],
      "bbox_max": [
        1267.0963134765625,
        1550.0,
        153.09242248535156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1250.0,
        1527.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1550.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1546.9998779296875,
      "bbox_min": [
        1250.0,
        1547.0,
        140.0
      ],
      "bbox_max": [
        1270.0,
        1547.0,
        147.77781677246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -143.0,
      "bbox_min": [
        1263.017333984375,
        1527.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1550.0,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.809033989906311,
        -0.5877618789672852,
        0.0
      ],
      "plane_d": -149.37646484375,
      "bbox_min": [
        1306.4185791015625,
        1544.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1550.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1263.017333984375,
        1527.0,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1550.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        -0.951056718826294,
        0.0
      ],
      "plane_d": 1875.2275390625,
      "bbox_min": [
        1302.4774169921875,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1550.0,
        147.29376220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        -0.587769091129303,
        0.0
      ],
      "plane_d": -146.3585205078125,
      "bbox_min": [
        1305.2725830078125,
        1547.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1550.0,
        147.29376220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1486.9998779296875,
      "bbox_min": [
        1250.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1506.9998779296875,
      "bbox_min": [
        1250.0,
        1487.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1263.017333984375,
        1507.0,
        140.0
      ],
      "bbox_max": [
        1309.255126953125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -142.99998474121094,
      "bbox_min": [
        1263.017333984375,
        1507.0,
        143.0
      ],
      "bbox_max": [
        1309.255126953125,
        1510.9044189453125,
        160.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1263.017333984375,
        1507.0,
        153.09242248535156
      ],
      "bbox_max": [
        1268.5347900390625,
        1510.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8823518753051758,
        -0.0,
        0.47059038281440735
      ],
      "plane_d": -1186.4696044921875,
      "bbox_min": [
        1263.017333984375,
        1487.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1507.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -142.99998474121094,
      "bbox_min": [
        1263.017333984375,
        1487.0,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1507.0,
        160.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.3090081810951233,
        -0.9510594606399536,
        -0.0
      ],
      "plane_d": 1829.423095703125,
      "bbox_min": [
        1299.4774169921875,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1505.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.809033989906311,
        -0.5877618789672852,
        0.0
      ],
      "plane_d": -175.8258056640625,
      "bbox_min": [
        1306.4185791015625,
        1499.0955810546875,
        140.0
      ],
      "bbox_max": [
        1310.7081298828125,
        1505.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3090165853500366,
        -0.951056718826294,
        -0.0
      ],
      "plane_d": 1832.429931640625,
      "bbox_min": [
        1263.017333984375,
        1487.0,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1505.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8090288043022156,
        -0.587769091129303,
        0.0
      ],
      "plane_d": -172.8082275390625,
      "bbox_min": [
        1305.2725830078125,
        1502.622314453125,
        143.0
      ],
      "bbox_max": [
        1307.0,
        1505.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7813422083854675,
        0.0,
        -0.6241029500961304
      ],
      "plane_d": -891.3033447265625,
      "bbox_min": [
        1263.017333984375,
        1487.0,
        153.09242248535156
      ],
      "bbox_max": [
        1268.5347900390625,
        1490.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -152.5,
      "bbox_min": [
        1275.0,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1479.0,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1297.0,
      "bbox_min": [
        1293.5,
        1460.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1478.0621337890625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659227728843689,
        0.25883039832115173,
        0.0
      ],
      "plane_d": -1633.80029296875,
      "bbox_min": [
        1293.5,
        1472.0,
        150.0
      ],
      "bbox_max": [
        1297.0,
        1478.0621337890625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1959.79052734375,
      "bbox_min": [
        1293.5,
        1475.5,
        150.0
      ],
      "bbox_max": [
        1296.0621337890625,
        1478.0621337890625,
        152.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1479.0,
        150.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1478.0,
      "bbox_min": [
        1275.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1478.92822265625,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6873481273651123,
        0.6873481273651123,
        0.23474466800689697
      ],
      "plane_d": -1938.831298828125,
      "bbox_min": [
        1293.5,
        1478.0,
        140.0
      ],
      "bbox_max": [
        1294.92822265625,
        1478.92822265625,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": -1293.199951171875,
      "bbox_min": [
        1290.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9389353394508362,
        0.25158241391181946,
        0.23474816977977753
      ],
      "plane_d": -1621.93212890625,
      "bbox_min": [
        1290.0,
        1472.0,
        140.0
      ],
      "bbox_max": [
        1298.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6873481273651123,
        0.6873481273651123,
        0.23474466800689697
      ],
      "plane_d": -1938.831298828125,
      "bbox_min": [
        1290.0,
        1475.0,
        140.0
      ],
      "bbox_max": [
        1296.92822265625,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1958.824462890625,
      "bbox_min": [
        1290.0,
        1475.0,
        140.0
      ],
      "bbox_max": [
        1295.1961669921875,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588146924972534,
        -0.965927004814148,
        -0.0
      ],
      "plane_d": 1761.5111083984375,
      "bbox_min": [
        1290.0,
        1477.1961669921875,
        140.0
      ],
      "bbox_max": [
        1293.0,
        1478.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": 1386.3623046875,
      "bbox_min": [
        1275.0,
        1475.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1277.5999755859375,
      "bbox_min": [
        1277.5999755859375,
        1475.0,
        144.0
      ],
      "bbox_max": [
        1277.5999755859375,
        1479.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        890.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        890.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        890.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1540.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7705407738685608,
        -0.6373907923698425,
        0.0
      ],
      "plane_d": 252.99041748046875,
      "bbox_min": [
        890.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        945.5584716796875,
        1540.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1470.0,
        140.0
      ],
      "bbox_max": [
        890.0,
        1472.83544921875,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -890.0,
      "bbox_min": [
        890.0,
        1460.0,
        140.0
      ],
      "bbox_max": [
        890.0,
        1470.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        440.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1660.0,
        1270.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1475.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1660.0,
        1235.4296875,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1530.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1530.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1555.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1555.0,
        1120.0,
        465.0
      ],
      "bbox_max": [
        1615.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1530.0,
        1120.0,
        465.0
      ],
      "bbox_max": [
        1535.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        1530.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        940.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1580.0,
        845.0,
        140.0
      ],
      "bbox_max": [
        1600.0,
        860.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1598.0,
        860.0,
        140.0
      ],
      "bbox_max": [
        1600.0,
        860.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -810.0,
      "bbox_min": [
        1600.0,
        810.0,
        140.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        1600.0,
        840.0,
        200.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1660.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071068286895752
      ],
      "plane_d": -989.9495849609375,
      "bbox_min": [
        1600.0,
        860.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -869.9999389648438,
      "bbox_min": [
        1600.0,
        870.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        200.0
      ],
      "bbox_max": [
        1620.0,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1615.0,
      "bbox_min": [
        1530.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1530.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1494.5458984375,
      "bbox_min": [
        1556.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1556.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1614.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1565.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1605.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1605.0001220703125,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1615.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1535.0,
      "bbox_min": [
        1530.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1565.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1530.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1535.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1555.0,
      "bbox_min": [
        1555.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1565.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1555.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1565.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1475.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1235.4296875,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1475.0,
        1120.0,
        465.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -141.0,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        157.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 558.7955932617188,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37629082798957825,
        -0.9265016913414001,
        0.0
      ],
      "plane_d": 1691.8072509765625,
      "bbox_min": [
        1494.6551513671875,
        1214.5703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37629082798957825,
        0.9265016913414001,
        0.0
      ],
      "plane_d": -578.1218872070312,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37629082798957825,
        0.9265016913414001,
        -0.0
      ],
      "plane_d": -1711.133544921875,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1235.4296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        0.3892177939414978,
        -0.0
      ],
      "plane_d": -1873.56640625,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": -919.9827270507812,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1516.3448486328125,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        -0.3892177939414978,
        0.0
      ],
      "plane_d": 1853.5870361328125,
      "bbox_min": [
        1494.6551513671875,
        1217.7266845703125,
        140.0
      ],
      "bbox_max": [
        1497.7283935546875,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211457371711731,
        0.3892177939414978,
        0.0
      ],
      "plane_d": 900.0033569335938,
      "bbox_min": [
        1494.6551513671875,
        1225.0,
        140.0
      ],
      "bbox_max": [
        1497.7283935546875,
        1232.2733154296875,
        141.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37631431221961975,
        -0.9264920949935913,
        0.0
      ],
      "plane_d": 563.24853515625,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37631431221961975,
        0.9264920949935913,
        0.0
      ],
      "plane_d": -573.57470703125,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -147.99998474121094,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        157.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.9211491346359253,
        0.389210045337677,
        -0.0
      ],
      "plane_d": -1869.06201171875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9211491346359253,
        -0.389210045337677,
        0.0
      ],
      "plane_d": 1858.0826416015625,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 146.0,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        141.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37631431221961975,
        -0.9264920949935913,
        0.0
      ],
      "plane_d": 1696.330810546875,
      "bbox_min": [
        1499.5404052734375,
        1219.42724609375,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37631431221961975,
        0.9264920949935913,
        -0.0
      ],
      "plane_d": -1706.6572265625,
      "bbox_min": [
        1499.5404052734375,
        1221.19482421875,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1230.57275390625,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211491346359253,
        -0.389210045337677,
        0.0
      ],
      "plane_d": -915.497314453125,
      "bbox_min": [
        1499.5404052734375,
        1221.19482421875,
        146.0
      ],
      "bbox_max": [
        1511.4595947265625,
        1228.80517578125,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211491346359253,
        0.389210045337677,
        0.0
      ],
      "plane_d": 904.5179443359375,
      "bbox_min": [
        1499.5404052734375,
        1225.0,
        146.0
      ],
      "bbox_max": [
        1501.148193359375,
        1228.80517578125,
        148.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37630537152290344,
        -0.9264957308769226,
        0.0
      ],
      "plane_d": 567.2664184570312,
      "bbox_min": [
        1503.8828125,
        1223.74462890625,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1226.25537109375,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37630537152290344,
        -0.9264957308769226,
        0.0
      ],
      "plane_d": 1700.3218994140625,
      "bbox_min": [
        1503.8828125,
        1223.74462890625,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1226.25537109375,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37630537152290344,
        0.9264957308769226,
        0.0
      ],
      "plane_d": -569.5926513671875,
      "bbox_min": [
        1503.8828125,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1226.25537109375,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37630537152290344,
        0.9264957308769226,
        -0.0
      ],
      "plane_d": -1702.6480712890625,
      "bbox_min": [
        1503.8828125,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1226.25537109375,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211454391479492,
        0.3892185688018799,
        -0.0
      ],
      "plane_d": -1865.06689453125,
      "bbox_min": [
        1503.8828125,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9211454391479492,
        -0.3892185688018799,
        0.0
      ],
      "plane_d": -911.4814453125,
      "bbox_min": [
        1503.8828125,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1507.1171875,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211454391479492,
        -0.3892185688018799,
        0.0
      ],
      "plane_d": 1862.087646484375,
      "bbox_min": [
        1503.8828125,
        1224.2774658203125,
        141.0
      ],
      "bbox_max": [
        1504.1881103515625,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9211454391479492,
        0.3892185688018799,
        0.0
      ],
      "plane_d": 908.5020751953125,
      "bbox_min": [
        1503.8828125,
        1225.0,
        141.0
      ],
      "bbox_max": [
        1504.1881103515625,
        1225.7225341796875,
        146.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 152.99998474121094,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        148.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3131498694419861,
        -0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": 386.3155517578125,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498396396637,
        -0.7712410092353821,
        0.5541882514953613
      ],
      "plane_d": 1329.209716796875,
      "bbox_min": [
        1502.2545166015625,
        1222.125732421875,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3131498694419861,
        0.7712409496307373,
        0.5541881918907166
      ],
      "plane_d": -560.33056640625,
      "bbox_min": [
        1502.2545166015625,
        1223.121337890625,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3131498396396637,
        0.7712410092353821,
        0.5541882514953613
      ],
      "plane_d": -1503.224853515625,
      "bbox_min": [
        1502.2545166015625,
        1223.121337890625,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1227.874267578125,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7378709316253662,
        0.3116414248943329,
        0.5986869931221008
      ],
      "plane_d": -1586.6192626953125,
      "bbox_min": [
        1502.2545166015625,
        1223.121337890625,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1226.878662109375,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737870991230011,
        -0.3116414248943329,
        0.5986870527267456
      ],
      "plane_d": -823.097900390625,
      "bbox_min": [
        1502.2545166015625,
        1223.121337890625,
        153.0
      ],
      "bbox_max": [
        1508.7454833984375,
        1226.878662109375,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7378709316253662,
        -0.3116414248943329,
        0.5986869931221008
      ],
      "plane_d": 1398.631591796875,
      "bbox_min": [
        1502.2545166015625,
        1223.121337890625,
        153.0
      ],
      "bbox_max": [
        1505.5,
        1226.878662109375,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.737870991230011,
        0.3116414248943329,
        0.5986870527267456
      ],
      "plane_d": 635.110107421875,
      "bbox_min": [
        1502.2545166015625,
        1225.0,
        153.0
      ],
      "bbox_max": [
        1505.5,
        1226.878662109375,
        157.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37619802355766296,
        -0.9265393614768982,
        0.0
      ],
      "plane_d": 567.9815063476562,
      "bbox_min": [
        1504.425537109375,
        1224.2843017578125,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        -0.9265393614768982,
        0.0
      ],
      "plane_d": 1700.7138671875,
      "bbox_min": [
        1504.425537109375,
        1224.2843017578125,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619802355766296,
        0.9265393614768982,
        0.0
      ],
      "plane_d": -569.3077392578125,
      "bbox_min": [
        1504.425537109375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.37619802355766296,
        0.9265393614768982,
        -0.0
      ],
      "plane_d": -1702.0400390625,
      "bbox_min": [
        1504.425537109375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.7156982421875,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9212018847465515,
        0.3890852630138397,
        -0.0
      ],
      "plane_d": -1864.48876953125,
      "bbox_min": [
        1504.425537109375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.3372802734375,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9212018847465515,
        -0.3890852630138397,
        0.0
      ],
      "plane_d": -911.2297973632812,
      "bbox_min": [
        1504.425537109375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1506.574462890625,
        1225.3372802734375,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9212018847465515,
        -0.3890852630138397,
        0.0
      ],
      "plane_d": 1862.509033203125,
      "bbox_min": [
        1504.425537109375,
        1224.6627197265625,
        148.0
      ],
      "bbox_max": [
        1504.5679931640625,
        1225.3372802734375,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9212018847465515,
        0.3890852630138397,
        0.0
      ],
      "plane_d": 909.2501831054688,
      "bbox_min": [
        1504.425537109375,
        1225.0,
        148.0
      ],
      "bbox_max": [
        1504.5679931640625,
        1225.3372802734375,
        153.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1480.0,
      "bbox_min": [
        1475.0,
        720.0,
        139.99998474121094
      ],
      "bbox_max": [
        1480.0,
        880.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1475.0,
        880.0,
        140.0
      ],
      "bbox_max": [
        1480.0,
        880.0,
        350.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1414.94287109375,
      "bbox_min": [
        1475.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1475.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1476.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1530.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1485.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1525.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1475.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1484.9998779296875,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1525.0001220703125,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1530.0,
        1079.9991455078125,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        440.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1475.0,
        1270.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1130.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1395.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1395.0,
        1120.0,
        465.0
      ],
      "bbox_max": [
        1455.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": -939.1484985351562,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        260.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1240.0,
        670.0,
        139.99998474121094
      ],
      "bbox_max": [
        1475.0,
        960.0,
        350.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        1280.0,
        670.0,
        140.0
      ],
      "bbox_max": [
        1472.0,
        880.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1472.0,
      "bbox_min": [
        1470.0,
        670.0,
        140.0
      ],
      "bbox_max": [
        1472.0,
        680.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -675.0,
      "bbox_min": [
        1470.0,
        675.0,
        140.0
      ],
      "bbox_max": [
        1472.0,
        675.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1280.0,
        820.0,
        170.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        1280.0,
        830.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1281.0,
        840.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        880.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        1281.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        860.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 178.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        860.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        850.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1395.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -161.1999969482422,
      "bbox_min": [
        1390.0,
        957.859619140625,
        161.1999969482422
      ],
      "bbox_max": [
        1395.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": -1335.3399658203125,
      "bbox_min": [
        1396.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1396.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1454.0,
        1120.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1405.0,
        1100.0,
        465.0
      ],
      "bbox_max": [
        1445.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1455.0,
      "bbox_min": [
        1445.0001220703125,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1445.0001220703125,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1455.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -465.0,
      "bbox_min": [
        1395.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1405.0,
        1120.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        962.6142578125,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1040.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1240.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1258.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1240.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1030.0,
        160.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -161.1999969482422,
      "bbox_min": [
        1390.0,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -982.6386108398438,
      "bbox_min": [
        1390.0,
        982.6386108398438,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -975.879638671875,
      "bbox_min": [
        1240.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1389.9998779296875,
      "bbox_min": [
        1240.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1050.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        1050.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1040.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        983.5406494140625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1215.0,
        1270.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1270.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        1270.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1000.0,
        1270.0,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        260.0
      ],
      "bbox_max": [
        1030.0,
        1270.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1170.0,
        260.0
      ],
      "bbox_max": [
        1030.0,
        1270.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1170.0,
        260.0
      ],
      "bbox_max": [
        1000.0,
        1270.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        983.5406494140625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        140.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1166.1483154296875,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": -1114.3089599609375,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1050.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        970.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1050.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1150.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        1160.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1170.0,
        970.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1030.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1186.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1173.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1109.5999755859375,
        380.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1180.0,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1180.0,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1187.0400390625,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1083.3333740234375,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1189.3616943359375,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1193.33349609375,
        1030.0,
        145.95767211914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1187.0400390625,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1030.0,
      "bbox_min": [
        1194.0799560546875,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1240.0,
        1030.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": -1112.6187744140625,
      "bbox_min": [
        1010.7999877929688,
        1091.9998779296875,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1173.0,
        1091.9998779296875,
        380.0
      ],
      "bbox_max": [
        1180.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.66571044921875,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1169.5999755859375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1040.4000244140625,
        1100.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1119.199951171875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320502638816833,
        0.5547001957893372
      ],
      "plane_d": -1004.00732421875,
      "bbox_min": [
        1046.6666259765625,
        1110.0,
        140.0
      ],
      "bbox_max": [
        1163.3333740234375,
        1113.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1173.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1180.0,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1180.0,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1039.16015625,
        825.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        825.0,
        140.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1093.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1050.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        1050.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.37615966796875,
      "bbox_min": [
        1135.85791015625,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.760986328125,
      "bbox_min": [
        1148.85791015625,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        868.6692504882812,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        861.330810546875,
        1120.0,
        170.0
      ],
      "bbox_max": [
        868.6692504882812,
        1121.3931884765625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        480.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        480.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        0.0
      ],
      "plane_d": -1355.414306640625,
      "bbox_min": [
        480.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        480.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1120.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        480.0,
        980.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        946.9471435546875,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        1045.0,
        160.0
      ],
      "bbox_max": [
        946.9471435546875,
        1110.0,
        170.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1083.890869140625,
        160.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        480.0,
        1000.0,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1100.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        891.3368530273438,
        1083.890869140625,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        0.9348779320716858,
        -0.0
      ],
      "plane_d": -1335.414306640625,
      "bbox_min": [
        865.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        891.3368530273438,
        1100.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        834.9939575195312,
        1110.0,
        170.0
      ],
      "bbox_max": [
        895.006103515625,
        1120.0,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.2073974609375,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        602.2073974609375,
        1185.6285400390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        714.611572265625,
        1270.0,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        647.2877197265625,
        1185.6285400390625,
        550.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        699.5303955078125,
        1223.5849609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        647.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1110.0,
      "bbox_min": [
        440.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1090.0,
      "bbox_min": [
        440.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        480.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        1090.0,
        140.0
      ],
      "bbox_max": [
        440.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}